export default {
  acceptTermsRequired: 'कृपया नियम और शर्तें स्वीकार करें',
  accountNumber: 'खाता संख्या',
  acknowledgeText: 'स्वीकारें',
  acknowledgedText: 'स्वीकार किया',
  active: 'ਸਰਗਰਮ',
  activeBookings: 'ਸਰਗਰਮ ਬੁਕਿੰਗਾਂ',
  activeBucketsText: 'सक्रिय बकेट',
  activeToday: 'ਅੱਜ ਸਰਗਰਮ',
  adminRole: 'ਐਡਮਿਨ — ਪ੍ਰਬੰਧਕੀ ਨਿਰਦੇਸ਼ਕ',
  advance: 'ਅਡਵਾਂਸ',
  advancePaid: 'अग्रिम भुगतान',
  advancePaidLabel: 'अग्रिम',
  agreeTermsCheckbox: 'मैंने सभी नियम और शर्तें पढ़ी हैं और स्वीकार की हैं',
  agreement: 'ਸ਼ਰਤਾਂ & ਸਮਝੌਤਾ',
  alertLog: 'ਚੇਤਾਵਨੀ ਲੌਗ',
  alertText: 'अलर्ट',
  alerts: 'ਚੇਤਾਵਨੀਆਂ',
  allAlerts: 'सभी चेतावनियाँ',
  allLoaded: 'सभी लोड',
  allMachinesOk: 'ਸਾਰੀਆਂ ਮਸ਼ੀਨਾਂ ਠੀਕ ਚੱਲ ਰਹੀਆਂ ਹਨ।',
  allStats: 'ਪੂਰੇ ਅੰਕੜੇ',
  allowedText: 'अनुमत',
  amount: 'ਰਾਸ਼ੀ',
  apiHealthTitle: 'API स्वास्थ्य',
  apiSloAlertsTitle: 'API SLO अलर्ट',
  appName: 'ਡਿਵੈਲਪਮੈਂਟ ਐਕਸਪ੍ਰੈਸ',
  approvals: 'अनुमोदन',
  approveAndDispatch: 'स्वीकृत करें और मशीन भेजें',
  approved: 'स्वीकृत',
  assignedOperator: 'नियुक्त ऑपरेटर',
  attemptsLabel: 'प्रयास',
  attendance: 'उपस्थिति',
  auditLogs: 'ऑडिट लॉग्स',
  available: 'ਉਪਲਬਧ',
  availableMachinery: 'उपलब्ध मशीनरी',
  availableNow: 'अभी उपलब्ध',
  avgRating: 'औसत रेटिंग',
  awaitingClientFeedback: 'क्लाइंट फीडबैक की प्रतीक्षा',
  awaitingDispatch: 'डिस्पैच की प्रतीक्षा',
  back: 'ਵਾਪਸ ਜਾਓ',
  backToLogin: 'लॉगिन पर वापस जाएं',
  bank: 'बैंक',
  bankDetailsTitle: 'बैंक विवरण',
  baseAmount: 'ਅਧਾਰ ਰਾਸ਼ੀ',
  billingWallet: 'ਵਾਲੇਟ & ਬਿਲਿੰਗ',
  blacklistWarning: '⛔ ਬਲੈਕਲਿਸਟ ਚੇਤਾਵਨੀ',
  blockedRateText: 'ब्लॉक दर',
  blockedText: 'ब्लॉक्ड',
  bookMachine: 'ਮਸ਼ੀਨ ਬੁੱਕ ਕਰੋ',
  bookMachineAction: 'मशीन बुक करें',
  bookNow: 'ਹੁਣੇ ਬੁੱਕ ਕਰੋ',
  bookingConfirm: 'ਬੁਕਿੰਗ ਪੁਸ਼ਟੀ ਕਰੋ',
  bookingCostCalculator: 'बुकिंग और लागत कैलकुलेटर',
  bookingFailedGeneric: 'बुकिंग विफल। पुनः प्रयास करें।',
  bookingHistory: 'ਬੁਕਿੰਗ ਇਤਿਹਾਸ',
  bookingReportTitle: 'बुकिंग रिपोर्ट',
  bookingScheduleSummary: 'दिन और महीने अनुसार बुकिंग शेड्यूल',
  bookingSelectMachineFirst: 'जारी रखने के लिए फ्लीट से मशीन चुनें।',
  bookingStepChoose: 'मशीन चुनें',
  bookingStepConfirm: 'पुष्टि और भुगतान',
  bookingStepCost: 'लागत और तारीख',
  bookingType: 'ਬੁਕਿੰਗ ਕਿਸਮ ਚੁਣੋ',
  bookingTypeLabel: 'बुकिंग प्रकार',
  bookingTypeText: 'बुकिंग प्रकार',
  bookingsCount: '{count} बुकिंग',
  bookingsScheduleHint: 'क्लाइंट बुकिंग करने पर दिनवार शेड्यूल यहाँ दिखेगा।',
  burstText: 'बर्स्ट',
  busy: 'ਰੁੱਝਿਆ',
  callNow: 'अभी कॉल करें',
  cancel: 'ਰੱਦ ਕਰੋ',
  cancelAction: 'रद्द करें',
  cancelBooking: 'ਬੁਕਿੰਗ ਰੱਦ ਕਰੋ',
  cancelBookingPrompt: 'बुकिंग रद्द करें?',
  cancelPolicy: 'ਰੱਦ ਕਰਨ ਦੀ ਨੀਤੀ',
  cancelText: 'रद्द करें',
  cancelWarning: 'ਕੀ ਤੁਸੀਂ ਰੱਦ ਕਰਨਾ ਚਾਹੁੰਦੇ ਹੋ?',
  changeLanguage: 'ਭਾਸ਼ਾ ਬਦਲੋ',
  changeMachine: 'मशीन बदलें',
  changeMobileNumber: 'Change mobile number',
  chipAction: 'क्रिया',
  chipActor: 'कर्ता',
  chipEntity: 'एंटिटी',
  chipFrom: 'से',
  chipMeta: 'मेटा',
  chipRole: 'भूमिका',
  chipTo: 'तक',
  clearAll: 'सभी साफ करें',
  client: 'ਗਾਹਕ',
  clientFeedbackLabel: 'क्लाइंट फीडबैक',
  clientPortal: 'क्लाइंट पोर्टल',
  clientRatingsTitle: 'क्लाइंट रेटिंग और सुझाव',
  clientRole: 'ਕਲਾਇੰਟ (ਠੇਕੇਦਾਰ)',
  clients: 'ਗਾਹਕ',
  commission: 'ਕਮਿਸ਼ਨ',
  commission15: 'कमीशन 15%',
  commissionPaid: 'कमीशन भुगतान',
  commissionRate: 'सकल बिलिंग का 15%',
  company: 'कंपनी',
  companyDetailsTitle: 'कंपनी विवरण',
  completeBookings: 'ਪੂਰੀਆਂ ਬੁਕਿੰਗਾਂ',
  completedBookings: 'ਪੂਰੀਆਂ ਬੁਕਿੰਗਾਂ',
  condition: 'ਸਥਿਤੀ',
  confirm: 'ਪੁਸ਼ਟੀ ਕਰੋ',
  confirmBooking: 'ਬੁਕਿੰਗ ਪੁਸ਼ਟੀ ਕਰੋ',
  confirmBookingAction: 'बुकिंग की पुष्टि करें',
  confirmCancel: 'रद्दीकरण पुष्टि करें',
  confirmPassword: 'Confirm password',
  confirmRetry: 'पुनः प्रयास की पुष्टि करें',
  contactCompany: 'डेवलपमेंट एक्सप्रेस से संपर्क करें',
  costCalculator: 'ਲਾਗਤ ਕੈਲਕੁਲੇਟਰ',
  crawlerNoRto: 'क्रॉलर (RTO नहीं)',
  currentlyDeployed: 'वर्तमान में तैनात',
  customAmount: 'ਕਸਟਮ ਰਾਸ਼ੀ (ਘੱਟੋ-ਘੱਟ ₹5,000)',
  cycles: "ਚੱਕਰ",
  dailyWorkReport: 'दैनिक कार्य रिपोर्ट',
  dashboard: 'ਡੈਸ਼ਬੋਰਡ',
  date: 'ਮਿਤੀ',
  dayMachinesLabel: 'मशीनें',
  days: 'ਦਿਨ',
  daysUnit: 'दिन',
  directContactBlacklist: 'सीधा संपर्क = ब्लैकलिस्ट',
  directContactProhibited: 'ਸਿੱਧਾ ਸੰਪਰਕ ਸਖ਼ਤੀ ਨਾਲ ਵਰਜਿਤ',
  directContactProhibitedText: 'सीधा संपर्क सख्त प्रतिबंधित',
  dispatched: 'भेजा गया',
  dlqMonitor: 'DLQ मॉनिटर',
  docChassisPlate: 'चेसिस / सीरियल प्लेट फोटो (RTO RC नहीं)',
  docEquipmentPhoto: 'पूर्ण मशीन फोटो (साइड व्यू)',
  docIdentity: 'PAN / आधार',
  docInsurance: 'बीमा प्रमाणपत्र',
  docInsuranceOptional: 'बीमा / उपकरण कवर (यदि उपलब्ध)',
  docMachineInvoice: 'मशीन खरीद / इनवॉइस',
  docPollution: 'प्रदूषण प्रमाणपत्र (PUC)',
  docRcBook: 'RC बुक (RTO पंजीकरण प्रमाणपत्र)',
  documentUploadTitle: 'दस्तावेज़ अपलोड',
  documents: 'ਦਸਤਾਵੇਜ਼ ਅਪਲੋਡ',
  download: 'ਡਾਊਨਲੋਡ',
  drawerMenu: 'मेनू',
  earnings: 'ਕਮਾਈ',
  email: 'ਈਮੇਲ ਸਹਾਇਤਾ',
  emailAddress: 'ਈਮੇਲ ਪਤਾ',
  emailAddressLabel: 'ईमेल पता',
  expandBookingHint: 'पूरी बुकिंग, रद्द करें और ऑपरेटर रेटिंग के लिए नीचे महीना/दिन सेक्शन expand करें।',
  experience: 'ਤਜਰਬਾ',
  exportCsv: 'CSV एक्सपोर्ट',
  failedText: 'असफल',
  feedbackAfterDispatch: 'मशीन डिस्पैच के बाद ऑपरेटर रेटिंग उपलब्ध होगी।',
  feedbackStatusAfterDispatch: 'डिस्पैच के बाद',
  feedbackStatusRateNow: 'ऑपरेटर रेट करें ↓',
  filterAll: 'सभी',
  filterCredit: 'क्रेडिट',
  filterDebit: 'डेबिट',
  filterCompleted: 'पूर्ण',
  filterCancelled: 'बंद',
  filterPending: 'लंबित',
  filterDisputed: 'विवादित',
  forgotPasswordChooseMethod: 'Choose email link or SMS OTP to reset your password.',
  forgotPasswordEmailDevHint: 'Local dev: open the API server terminal and copy the “Password reset link (development)” URL.',
  forgotPasswordEmailHint: 'Enter your registered admin email address.',
  forgotPasswordFailed: 'Could not send reset link. Please try again.',
  forgotPasswordIntro: 'We will email a secure reset link to your registered email address.',
  forgotPasswordInvalidEmail: 'Please enter a valid email address.',
  forgotPasswordInvalidOtp: 'Enter the 6-digit OTP from SMS.',
  forgotPasswordInvalidPhone: 'Please enter a valid 10-digit mobile number.',
  forgotPasswordLink: 'Forgot password?',
  forgotPasswordOtpSentTo: 'OTP sent to',
  forgotPasswordPhoneHint: 'Enter your registered mobile number. Reset link goes to the email on your account.',
  forgotPasswordSendOtp: 'Send OTP',
  forgotPasswordSending: 'Sending...',
  forgotPasswordSendingOtp: 'Sending OTP...',
  forgotPasswordSmsDevHint: 'SMS not configured in production yet — in development, check server logs for the OTP code.',
  forgotPasswordSmsFailed: 'Could not send OTP. Please try again.',
  forgotPasswordSmsHint: 'Enter your registered mobile number. A 6-digit OTP will be sent by SMS.',
  forgotPasswordSmsSuccess: 'If an account exists, OTP was sent to the registered mobile number.',
  forgotPasswordSubmit: 'Send reset link',
  forgotPasswordSuccess: 'If an account exists, reset instructions were sent to the registered email.',
  forgotPasswordTitle: 'Reset your password',
  formLabel: 'फॉर्म',
  fuel: 'ਬਾਲਣ',
  fuelColon: 'ईंधन:',
  fuelHistoryTitle: 'ईंधन इतिहास',
  fuelLevel: 'ਬਾਲਣ ਪੱਧਰ',
  fuelLevelUpdate: 'फ्यूल स्तर अपडेट',
  fuelNotePlaceholder: 'नोट: भरा / उपयोग ईंधन...',
  fullName: 'पूरा नाम',
  goBook: '→ ਮਸ਼ੀਨ ਬੁੱਕ ਕਰੋ',
  gpsLiveLabel: '🟢 GPS लाइव',
  grandTotal: 'ਕੁੱਲ ਜੋੜ',
  grandTotalText: 'कुल योग',
  gross: 'सकल',
  grossBilling: 'ਕੁੱਲ ਬਿਲਿੰਗ',
  gst18: 'GST (18%)',
  gstInvoice: 'GST ਇਨਵੌਇਸ',
  gstInvoices: 'GST इनवॉइस',
  gstin: 'GSTIN',
  hide: 'छुपाएं',
  highTrend: 'HIGH ट्रेंड',
  hitsText: 'हिट्स',
  hmrHrs: 'घंटे',
  hmrToday: 'ਅੱਜ ਦਾ HMR',
  hmrTotal: 'ਕੁੱਲ HMR',
  home: 'होम',
  hours: 'ਘੰਟੇ',
  hrsUnit: 'घंटे',
  idle: 'ਅਕਿਰਿਆਸ਼ੀਲ',
  ifsc: 'IFSC',
  ignition: 'ਇਗਨੀਸ਼ਨ',
  importantInfo: 'ਮਸ਼ੀਨ ਮਾਲਕਾਂ ਲਈ ਮਹੱਤਵਪੂਰਨ ਜਾਣਕਾਰੀ',
  instantCost: 'ਤੁਰੰਤ ਲਾਗਤ ਕੈਲਕੁਲੇਟਰ',
  invoiceNotAvailableCancelled: 'इनवॉइस उपलब्ध नहीं (रद्द)',
  iot: 'IoT & GPS',
  issueReportTitle: 'समस्या रिपोर्ट',
  issueReportedSuccess: 'इश्यू यशस्वीरित्या नोंदवला!',
  issues: 'समस्याएं',
  joinUsAction: 'Join Us — मुफ्त रजिस्टर करें',
  joinUsBanner: 'मशीन किराए पर चाहिए?',
  joinUsHint: 'नए ग्राहक? JCB, excavator, crane बुक करने के लिए मुफ्त रजिस्टर करें।',
  landingCtaApp: 'Development Express खोलें',
  landingFeatBook: 'मिनटों में बुकिंग',
  landingFeatBookDesc: 'JCB, excavator, crane — live availability.',
  landingFeatPay: 'Wallet payments',
  landingFeatPayDesc: 'GST invoice, transparent billing.',
  landingFeatTrack: 'Live GPS',
  landingFeatTrackDesc: 'हर घंटे machine location पता करें।',
  landingHeroLine1: 'Smarter & Simpler.',
  landingHeroLine2: 'महाराष्ट्र का smart machinery rental.',
  landingSocialProof: 'महाराष्ट्र भर के builders और contractors जुड़े हैं।',
  landingStatMachines: 'मशीनें',
  landingStatRating: 'रेटिंग',
  landingTrustLine: 'Wallet-only · GST · Secured',
  lastRefreshed: 'अंतिम रिफ्रेश',
  live: 'ਲਾਈਵ',
  liveBookAvail: 'ਬੁਕਿੰਗ ਤੋਂ ਬਾਅਦ ਲਾਈਵ ਫੀਡ ਉਪਲਬਧ',
  liveCamera: '360° ਲਾਈਵ ਕੈਮਰਾ — ਬੁਕਿੰਗ ਤੋਂ ਬਾਅਦ',
  liveMachineLocation: 'लाइव मशीन स्थान',
  liveText: 'लाइव',
  liveTracking: 'ਲਾਈਵ ਟਰੈਕਿੰਗ',
  loadMoreAlerts: 'और अलर्ट लोड करें',
  loadMoreAttendance: 'और उपस्थिति लोड करें',
  loadMoreBookings: 'और बुकिंग लोड करें',
  loadMoreDlq: 'और DLQ लोड करें',
  loadMoreFuelLogs: 'और फ्यूल लॉग लोड करें',
  loadMoreLogs: 'और लॉग लोड करें',
  loadMoreMachines: 'और मशीनें लोड करें',
  loadMoreTransactions: 'और ट्रांजैक्शन लोड करें',
  loadMoreUsers: 'और यूजर्स लोड करें',
  loadedBookings: 'लोड की गई बुकिंग',
  loadedDlqItems: 'लोडेड DLQ आइटम',
  loadedFuelLogs: 'लोड किए गए फ्यूल लॉग',
  loadedOwnerBookings: '{count} मालिक बुकिंग लोड{suffix}',
  loading: 'लोड हो रहा है...',
  loadingDashboard: 'डैशबोर्ड लोड हो रहा है...',
  location: 'ਸਥਾਨ',
  lockConfirm: '🔒 ਲੌਕ ਪੁਸ਼ਟੀ ਕਰੋ',
  lockMachine: 'ਮਸ਼ੀਨ ਲੌਕ ਕਰੋ',
  lockWarning: 'Teltonika GPS ਰਾਹੀਂ ਮਸ਼ੀਨ ਦਾ ਇਗਨੀਸ਼ਨ ਦੂਰੋਂ ਬੰਦ ਕੀਤਾ ਜਾਵੇਗਾ।',
  locked: 'ਲੌਕ',
  loginAs: 'लॉगिन हो रहे हैं',
  loginChangeRole: 'भूमिका बदलें',
  loginClientPortalSubtitle: 'निर्माण मशीनरी बुक करने के लिए साइन इन करें',
  loginEmailHint: 'एडमिन लॉगिन के लिए रजिस्टर्ड ईमेल इस्तेमाल करें।',
  loginFailedGeneric: 'लॉगिन असफल — कृपया फिर से प्रयास करें',
  loginIAmQuestion: 'मैं कौन…?',
  loginModeOtp: 'OTP लॉगिन',
  loginModePassword: 'पासवर्ड',
  loginNewHereRegister: 'नए हैं? रजिस्टर करें',
  loginOtpDevHint: 'Development: SMS न हो तो server log में OTP देखें।',
  loginOtpHint: 'रजिस्टर्ड मोबाइल पर 6 अंकों का OTP भेजा जाएगा।',
  loginOtpSentTo: 'OTP भेजा:',
  loginOwnerPortalSubtitle: 'अपनी फ्लीट और पंजीकरण प्रबंधित करने के लिए साइन इन करें',
  loginPhoneHint: 'क्लाइंट, ओनर और ऑपरेटर लॉगिन के लिए रजिस्टर्ड मोबाइल नंबर इस्तेमाल करें।',
  loginPickRoleHint: 'पंजीकृत? भूमिका चुनें। नए हैं? नीचे Join Us।',
  loginPortalAdminSubtitle: 'प्लेटफ़ॉर्म नियंत्रण और अनुमोदन',
  loginPortalAdminTitle: 'एडमिन पोर्टल',
  loginPortalClientSubtitle: 'निर्माण मशीनरी बुक करने के लिए साइन इन',
  loginPortalClientTitle: 'क्लाइंट पोर्टल',
  loginPortalOperatorSubtitle: 'नियुक्त मशीन और दैनिक लॉग के लिए साइन इन',
  loginPortalOperatorTitle: 'ऑपरेटर पोर्टल',
  loginPortalOwnerSubtitle: 'फ्लीट और पंजीकरण प्रबंधित करने के लिए साइन इन',
  loginPortalOwnerTitle: 'मालिक पोर्टल',
  loginRoleAdminDesc: 'प्लेटफ़ॉर्म नियंत्रण, अनुमोदन और संचालन',
  loginRoleClientDesc: 'निर्माण परियोजनाओं के लिए मशीनरी बुक करें',
  loginRoleClientShort: 'क्लाइंट',
  loginRoleOperatorDesc: 'नियुक्त मशीन और दैनिक लॉग',
  loginRoleOwnerDesc: 'फ्लीट, कमाई और उपलब्धता प्रबंधित करें',
  loginRoleOwnerShort: 'ओनर',
  loginSendOtp: 'OTP भेजें',
  loginSendingOtp: 'OTP भेज रहे हैं...',
  loginSignInShort: 'साइन इन',
  loginTabOtp: 'OTP',
  loginTabPassword: 'पासवर्ड',
  loginVerifyOtp: 'Verify करें',
  loginVerifyingOtp: 'Verify हो रहा है...',
  logout: 'ਲੌਗਆਉਟ',
  sessionRevokedAlert: 'ਤੁਸੀਂ ਕਿਸੇ ਹੋਰ ਡਿਵਾਈਸ \'ਤੇ ਲੌਗ ਇਨ ਹੋ। ਕਿਰਪਾ ਕਰਕੇ ਦੁਬਾਰਾ ਲੌਗਇਨ ਕਰੋ।',
  machine: 'ਮਸ਼ੀਨ',
  machineDefaultLabel: 'मशीन',
  machineDetails: 'ਮਸ਼ੀਨ & ਆਪਰੇਟਰ ਵੇਰਵੇ',
  machineDetailsTitle: 'मशीन विवरण',
  machineDispatchedAt: 'मशीन भेजी गई — {when}',
  machineHours: 'मशीन घंटे',
  machineIdLabel: 'मशीन ID',
  machineInfo: 'ਮਸ਼ੀਨ ਦੀ ਜਾਣਕਾਰੀ',
  machineLabel: 'मशीन',
  machineLog: 'मशीन लॉग',
  machineReg: 'ਮਸ਼ੀਨ ਰਜਿਸਟ੍ਰੇਸ਼ਨ ਫਾਰਮ',
  machineRegistrationSubmitted: 'मशीन नोंदणी सबमिट झाली! DE टीम 24 तासांत पडताळणी करेल.',
  machineRegistrationTitle: 'मशीन पंजीकरण',
  machineStatus: 'ਮਸ਼ੀਨ ਸਥਿਤੀ',
  machineStatusTitle: 'मशीन स्थिति',
  machines: 'ਮਸ਼ੀਨਾਂ',
  marketingBackHome: 'वेबसाइट होम',
  marketingBadge: 'लाइव ऑपरेशन · कराड, सातारा',
  marketingBuiltFor: 'सटीकता, अनुपालन और गति चाहने वाली भारतीय निर्माण टीमों के लिए।',
  marketingCtaBook: 'मशीन बुक करें',
  marketingCtaLogin: 'Development Express खोलें — लॉगिन',
  marketingCtaWhatsApp: 'WhatsApp करें',
  marketingFooterRights: '2026 डेवलपमेंट एक्सप्रेस · कराड, सातारा',
  marketingHeadline: 'महाराष्ट्र का अग्रणी मशीनरी रेंटल प्लेटफॉर्म',
  marketingLead: 'रीयल-टाइम GPS, डिजिटल वॉलेट भुगतान, और निर्माण मशीनरी के लिए स्वचालित संचालन। 2011 से सेवा में।',
  marketingNavContact: 'संपर्क',
  marketingNavLogin: 'प्लेटफॉर्म लॉगिन →',
  marketingNavServices: 'सेवाएँ',
  marketingNavTech: 'प्रौद्योगिकी',
  marketingServicesTitle: 'हम क्या देते हैं',
  marketingStatDigital: 'डिजिटल भुगतान',
  marketingStatFleet: 'लाइव मशीनें',
  marketingStatYears: 'वर्षों का अनुभव',
  marketingSvcOps: 'पूर्ण संचालन सूट',
  marketingSvcOpsSub: 'मालिक, ऑपरेटर, क्लाइंट — एक प्लेटफॉर्म।',
  marketingSvcPay: 'केवल वॉलेट निपटान',
  marketingSvcPaySub: 'GST इनवॉइस — साइट पर नकद नहीं।',
  marketingSvcTrack: 'GPS और लाइव स्थिति',
  marketingSvcTrackSub: 'Teltonika से जुड़ी फ्लीट दृश्यता।',
  marketingTechLead: 'Development Express बुकिंग, अनुपालन और फील्ड टेलीमेट्री को एक ही वर्कफ़्लो में जोड़ता है।',
  md: 'MD',
  mediumTrend: 'MEDIUM ट्रेंड',
  minAdvanceRequired: 'न्यूनतम अग्रिम आवश्यक',
  minimumAdvance: 'ਘੱਟੋ-ਘੱਟ ਅਡਵਾਂਸ ਲੋੜੀਂਦਾ',
  minimumRecharge: 'UPI/कार्ड/QR के लिए न्यूनतम ₹1।',
  moUnit: 'महीने',
  mobileNumber: 'मोबाइल नंबर',
  monthMachineSummary: 'इस महीने की मशीनें',
  monthTotalLabel: 'महीने का कुल',
  months: 'ਮਹੀਨੇ',
  moreAvailable: 'और उपलब्ध',
  myBookings: 'ਮੇਰੀਆਂ ਬੁਕਿੰਗਾਂ',
  myClientRating: 'मेरी क्लाइंट रेटिंग',
  myMachines: 'ਮੇਰੀਆਂ ਮਸ਼ੀਨਾਂ',
  neftRtgs: 'NEFT/RTGS',
  netEarnedMonth: 'नेट कमाई (माह)',
  netPaid: 'नेट भुगतान',
  netPayable: 'ਸ਼ੁੱਧ ਦੇਣਯੋਗ',
  netReceived: 'नेट प्राप्त',
  netReceivedCaps: 'नेट प्राप्त',
  neverText: 'कभी नहीं',
  newBooking: 'नई बुकिंग',
  newClientRegister: 'नया क्लाइंट? यहां रजिस्टर करें',
  newClientRegistration: 'नया क्लाइंट पंजीकरण',
  newPassword: 'New password',
  nextText: 'आगे',
  noAlerts: 'ਕੋਈ ਚੇਤਾਵਨੀ ਨਹੀਂ!',
  noAlertsNow: 'अभी कोई अलर्ट नहीं।',
  noBankRefund: '❌ ਬੈਂਕ ਰਿਫੰਡ ਨਹੀਂ — ਸਿਰਫ਼ ਵਾਲੇਟ ਕ੍ਰੈਡਿਟ',
  noBookings: 'ਕੋਈ ਸਰਗਰਮ ਬੁਕਿੰਗ ਨਹੀਂ',
  noBookingsAccount: 'इस खाते के लिए अभी तक कोई बुकिंग नहीं।',
  noBookingsYet: 'अभी तक कोई बुकिंग नहीं',
  noClientFeedbackYet: 'अभी कोई क्लाइंट रेटिंग नहीं। डिस्पैच के बाद क्लाइंट फीडबैक यहाँ दिखेगा।',
  noDlqItems: 'कोई DLQ आइटम नहीं',
  noFileSelected: 'कोई फ़ाइल नहीं',
  noMachinesDashboard: 'अभी कोई मशीन नहीं। फ्लीट जोड़ने के लिए मशीन पंजीकरण करें।',
  noMachinesTrack: 'ट्रैक करने के लिए कोई मशीन नहीं',
  noMachinesTrackHint: 'GPS ट्रैकिंग के लिए मशीन पंजीकृत करें।',
  noMachinesYet: 'अभी कोई मशीन पंजीकृत नहीं',
  noMoreAuditLogs: 'वर्तमान फिल्टर के लिए और ऑडिट लॉग नहीं मिले।',
  noRecentApiSloBreach: 'हाल में कोई API SLO breach संकेत नहीं।',
  noRecentFailedLogins: 'हाल में कोई असफल लॉगिन प्रयास नहीं।',
  noRefund: 'ਰਿਫੰਡ ਨਹੀਂ ਨੀਤੀ',
  noSecuritySignalsFound: 'कोई सुरक्षा संकेत नहीं मिले।',
  noTransactionsFilter: 'चयनित फ़िल्टर के लिए कोई लेनदेन नहीं।',
  normalText: 'सामान्य',
  off: 'बंद',
  officeLabel: 'ऑफिस',
  on: 'चालू',
  operator: 'ਆਪਰੇਟਰ',
  operatorFeedbackColumn: 'ऑपरेटर फीडबैक',
  operatorFeedbackSaved: 'धन्यवाद! आपका फीडबैक सेव हो गया।',
  operatorFeedbackSubmitted: 'आपका फीडबैक',
  operatorFeedbackTitle: 'ऑपरेटर फीडबैक',
  operatorPortal: 'ऑपरेटर पोर्टल',
  operatorRole: 'ਆਪਰੇਟਰ',
  operatorSatisfactionQuestion: 'क्या आप ऑपरेटर से संतुष्ट हैं?',
  operatorSuggestionPlaceholder: 'सुझाव या फीडबैक (वैकल्पिक)',
  operators: 'ਆਪਰੇਟਰ',
  optionalLabel: '(वैकल्पिक)',
  otpCode: 'OTP code',
  overview: 'ਸੰਖੇਪ ਜਾਣਕਾਰੀ',
  ownerBookingsAllLoaded: ' (सभी लोड)',
  ownerBookingsMoreAvailable: ' (और उपलब्ध)',
  ownerInfo: 'ਮਾਲਕ ਦੀ ਜਾਣਕਾਰੀ',
  ownerPortal: 'ओनर पोर्टल',
  ownerRole: 'ਮਸ਼ੀਨ ਮਾਲਕ',
  owners: 'ਮਾਲਕ',
  password: 'ਪਾਸਵਰਡ',
  passwordsMustMatch: 'Password and confirm password must match.',
  pastIssuesTitle: 'पिछली समस्याएं',
  payNow: 'ਹੁਣ ਭੁਗਤਾਨ ਕਰੋ',
  payNowText: 'अभी भुगतान करें',
  paymentBreakdownTitle: 'भुगतान विवरण — अप्रैल 2026',
  paymentCycle: 'भुगतान चक्र',
  paymentFailed: 'पेमेंट अयशस्वी! कृपया पुन्हा प्रयत्न करा.',
  paymentHistory: 'ਭੁਗਤਾਨ ਇਤਿਹਾਸ',
  paymentHistoryTitle: 'भुगतान इतिहास',
  paymentMethods: 'ਭੁਗਤਾਨ ਦੇ ਤਰੀਕੇ',
  paymentMode: 'भुगतान मोड',
  paymentSuccess: 'पेमेंट यशस्वी!',
  pdfInvoiceFailed: 'इनवॉइस PDF नहीं बन सका। पुनः प्रयास करें।',
  pdfReportFailed: 'रिपोर्ट PDF नहीं बन सका। पुनः प्रयास करें।',
  pdiCompleted: '✅ PDI / सुरक्षा निरीक्षण पूर्ण',
  pdiCrawlerHint: 'क्रॉलर: प्रदूषण (PUC) आवश्यक नहीं — RTO पंजीकृत नहीं।',
  pdiInfo: 'PDI ਜਾਂਚ',
  pdiInsuranceApplicable: '✅ बीमा / कवर (यदि लागू)',
  pdiInsuranceValid: '✅ बीमा वैध और अद्यतन',
  pdiPollutionValid: '✅ प्रदूषण प्रमाणपत्र (PUC) वैध',
  pdiTitle: 'प्री-डिलीवरी निरीक्षण (PDI)',
  penaltyDeduct: 'ਰੱਦ ਕਰਨ ਦਾ ਜੁਰਮਾਨਾ (1 ਘੰਟਾ)',
  pending: 'लंबित',
  pendingApproval: 'स्वीकृति लंबित',
  pendingCount: '{count} लंबित',
  pendingDispatch: 'डिस्पैच प्रतीक्षेत',
  perDay: 'ਪ੍ਰਤੀ ਦਿਨ',
  perHour: 'ਪ੍ਰਤੀ ਘੰਟਾ',
  perMonth: 'ਪ੍ਰਤੀ ਮਹੀਨਾ',
  perWeek: 'ਪ੍ਰਤੀ ਹਫ਼ਤਾ',
  phone: 'फ़ोन',
  platform: 'ਨਿਰਮਾਣ ਪ੍ਰਬੰਧਨ ਪਲੇਟਫਾਰਮ',
  platformAgreement: 'प्लेटफॉर्म समझौता',
  policyLabel: 'नीति',
  policyTopicBooking: 'बुकिंग',
  policyTopicCancellation: 'रद्दीकरण',
  policyTopicContact: 'संपर्क',
  policyTopicGst: 'GST',
  policyTopicHours: 'सपोर्ट समय',
  portalBackLink: 'पोर्टल',
  portalClient: 'क्लाइंट',
  portalClientSub: 'मशीनरी बुक करें',
  portalNewClientRegister: 'नए क्लाइंट? रजिस्टर करें',
  portalNewOwnerRegister: 'नए ओनर? रजिस्टर करें',
  portalOwner: 'ओनर',
  portalOwnerSub: 'फ्लीट प्रबंधन',
  portalStaffAdmin: 'एडमिन',
  portalStaffOperator: 'ऑपरेटर',
  portalWelcome: 'स्वागत है',
  portalWelcomeHint: 'जारी रखने के लिए अपना पोर्टल चुनें',
  quantityLabel: 'मात्रा',
  quickIssueReport: 'त्वरित समस्या रिपोर्ट',
  quickRechargeUpi: 'UPI से त्वरित रिचार्ज',
  quickSelect: 'त्वरित चयन:',
  rateCard: 'ਦਰ ਕਾਰਡ (ਆਪਰੇਟਰ ਸਮੇਤ)',
  rateLimitTelemetryTitle: 'रेट लिमिट टेलीमेट्री',
  rateOperatorWork: 'ऑपरेटर का काम रेट करें (1–5 स्टार)',
  rating: 'ਰੇਟਿੰਗ',
  receiptId: 'रसीद ID',
  recentAlerts: 'हाल की चेतावनियाँ',
  recentFailedLoginsTitle: 'हाल की असफल लॉगिन',
  recentLabel: 'हाल का',
  recharge: 'ਰੀਚਾਰਜ',
  rechargeFirst: '⚡ ਪਹਿਲਾਂ ਵਾਲੇਟ ਰੀਚਾਰਜ ਕਰੋ',
  rechargeWallet: '+ ਵਾਲੇਟ ਰੀਚਾਰਜ',
  ref: 'ਹਵਾਲਾ ਨੰ.',
  refreshText: 'रिफ्रेश',
  refreshingText: 'रिफ्रेश हो रहा है...',
  regCapacitySpecs: 'क्षमता / विवरण',
  regDocCrawlerHint: 'क्रॉलर: चेसिस प्लेट, खरीद इनवॉइस, फोटो और ID। बीमा वैकल्पिक।',
  regDocWheeledHint: 'व्हील्ड: RC (RTO), बीमा, PUC और ID (अधिकतम 5MB प्रत्येक)।',
  regEquipmentCategory: 'उपकरण श्रेणी *',
  regFailed: 'पंजीकरण विफल। कृपया पुनः प्रयास करें।',
  regFileSizeError: 'प्रत्येक दस्तावेज़ अधिकतम 5MB',
  regFileTypeError: 'केवल PDF, JPG, PNG या WEBP अनुमत',
  regFleetIdOptional: 'फ्लीट / चेसिस ID (वैकल्पिक)',
  regMachineCategory: 'मशीन श्रेणी *',
  regMachineInfoTitle: 'मशीन जानकारी',
  regMachineIntro: 'केवल निर्माण heavy equipment — कोई ट्रक/ट्रांसपोर्ट नहीं। व्हील्ड (JCB 3DX) के लिए RTO; क्रॉलर (Poclain) साइट पर — RTO passing नहीं।',
  regMachineNameModel: 'मशीन नाम / मॉडल',
  regMobilityTracked: 'क्रॉलर',
  regMobilityTrackedHint: 'Poclain / chain excavator, dozer — साइट उपकरण, RTO passing नहीं',
  regMobilityWheeled: 'व्हील्ड',
  regMobilityWheeledHint: 'JCB 3DX, wheeled loader, grader — RTO (RC) वाला निर्माण उपकरण',
  machineFinancialSection: 'मशीन खरीद विवरण (वैकल्पिक)',
  machineOwnershipType: 'स्वामित्व प्रकार',
  machineOwnershipNew: 'नई मशीन',
  machineOwnershipUsed: 'ਅਸਲ ਮਾਲਕ',
  machineOwnershipSecondHand: 'ਪੂਰਵ-ਮਾਲਕੀ',
  machinePurchasePrice: 'खरीद मूल्य (₹)',
  machinePurchasePriceHint: 'इस मशीन के लिए आपने जो राशि चुकाई',
  machinePurchaseDate: 'खरीद तिथि',
  machineYearOfManufacture: 'निर्माण वर्ष',
  machineLoanSection: 'इस मशीन पर मेरा loan है',
  machineLoanAmount: 'Loan राशि (₹)',
  machineLoanEmi: 'मासिक EMI (₹)',
  machineLoanTenure: 'Loan अवधि (महीने)',
  machineLoanStartDate: 'Loan शुरू तिथि',
  machineFuelConsumption: 'ईंधन खपत (L/hr)',
  machineMonthlyOperatingExpenses: 'ਮਾਸਿਕ ਚਲਾਣ ਖਰਚੇ',
  machineOperatorMonthlySalary: 'ਆਪਰੇਟਰ ਮਾਸਿਕ ਤਨਖਾਹ',
  machineServiceMonthly: 'ਸਰਵਿਸ / ਰੱਖ-ਰਖਾਅ (ਮਾਸਿਕ)',
  machineBreakdownMonthly: 'ਬ੍ਰੇਕਡਾਊਨ / ਮੁਰੰਮਤ (ਮਾਸਿਕ ਔਸਤ)',
  machineMaterialsMonthly: 'ਸਮੱਗਰੀ / ਉਪਭੋਗ ਯੋਗ (ਮਾਸਿਕ)',
  recoveryPlan: 'ਰਿਕਵਰੀ ਪਲਾਨ',
  recoveryOnTrack: "ਸਹੀ ਰਾਹ 'ਤੇ",
  recoveryNeedsAttention: 'ਧਿਆਨ ਚਾਹੀਦਾ',
  recoveryActionRequired: 'ਕਾਰਵਾਈ ਜ਼ਰੂਰੀ',
  recoveryAddPrice: 'ਰਿਕਵਰੀ ਪਲਾਨ ਦੇਖਣ ਲਈ ਖਰੀਦ ਮੁਲ੍ਯ ਜੋਡੌ',
  recoveryProgress: 'ਨਿਵੇਸ਼ ਵਸੂਲੀ',
  recoveryDailyNet: 'ਰੋਜ਼ਾਨਾ ਸ਼ੁੱਧ ਆਮਦਨ',
  recoveryDays: 'ਰਿਕਵਰੀ ਮਿਆਦ',
  recoveryProjectedDate: 'ਅਨੁਮਾਨਿਤ ਰਿਕਵਰੀ ਮਿਤੀ',
  recoveryRoi: 'ਸਾਲਾਨਾ ਵਾਪਸੀ',
  recoveryCurrentValue: 'ਮੌਜੂਦਾ ਮਸ਼ੀਨ ਮੁੱਲ',
  editFinancialDetails: 'ਵਿੱਤੀ ਵੇਰਵੇ ਸੰਪਾਦਿਤ ਕਰੋ',
  financialDetailsSaved: 'ਵਿੱਤੀ ਵੇਰਵੇ ਸੇਵ ਹੋ ਗਏ',
  recoveryBackfillNudge: 'ਰਿਕਵਰੀ ਟ੍ਰੈਕਿੰਗ ਅਨਲੌਕ ਕਰਨ ਲਈ {{count}} ਮਸ਼ੀਨ(ਾਂ) ਵਿੱਚ ਖਰੀਦ ਵੇਰਵੇ ਜੋੜੋ',
  dieselPriceTitle: 'ਡੀਜ਼ਲ ਦੀ ਕੀਮਤ',
  dieselPriceUpdate: 'ਡੀਜ਼ਲ ਕੀਮਤ ਅਪਡੇਟ ਕਰੋ',
  dieselPriceLatest: 'ਤਾਜ਼ਾ ਕੀਮਤ',
  dieselPriceNoRecord: 'ਕੋਈ ਡੀਜ਼ਲ ਕੀਮਤ ਦਰਜ ਨਹੀਂ',
  dieselPricePerLitre: 'ਲੀਟਰ ਕੀਮਤ (₹)',
  dieselQuantity: 'ਭਰੀ ਮਾਤਰਾ (ਲੀਟਰ)',
  dieselTaluka: 'ਸ਼ਹਿਰ / ਇਲਾਕਾ',
  bookingAttachment: 'ਅਟੈਚਮੈਂਟ ਚੁਣੋ',
  bookingAttachmentNone: 'ਕੋਈ ਖਾਸ ਅਟੈਚਮੈਂਟ ਨਹੀਂ',
  bookingWorkDescription: 'ਕੰਮ ਦਾ ਵੇਰਵਾ',
  bookingWorkDescriptionPlaceholder: 'ਜਿਵੇਂ ਨੀਂਹ ਖੁਦਾਈ, ਟ੍ਰੈਂਚਿੰਗ, ਪਾਈਪਲਾਈਨ ਕੰਮ',
  bookingAttachmentLabel: 'ਅਟੈਚਮੈਂਟ',
  bookingSiteLabel: 'ਸਾਈਟ',
  bookingWorkLabel: 'ਕੰਮ',
  termsAccept: "ਮੈਂ ਨਿਯਮਾਂ ਅਤੇ ਸ਼ਰਤਾਂ ਨਾਲ ਸਹਿਮਤ ਹਾਂ",
  termsRequired: "ਰਜਿਸਟਰ ਲਈ ਨਿਯਮ ਅਤੇ ਸ਼ਰਤਾਂ ਸਵੀਕਾਰ ਕਰਨੀਆਂ ਲਾਜ਼ਮੀ ਹਨ",
  termsLink: "ਨਿਯਮ ਅਤੇ ਸ਼ਰਤਾਂ",
  clientBlacklisted: "ਬਲੈਕਲਿਸਟ",
  clientBlacklistReason: "ਬਲੈਕਲਿਸਟ ਦਾ ਕਾਰਨ",
  clientBlacklistConfirm: "ਇਸ ਕਲਾਇੰਟ ਨੂੰ ਬਲੈਕਲਿਸਟ ਕਰਨਾ ਹੈ?",
  clientUnblacklist: "ਬਲੈਕਲਿਸਟ ਤੋਂ ਹਟਾਓ",
  blacklistedClients: "ਬਲੈਕਲਿਸਟ ਕਲਾਇੰਟ",
  blacklistedClientsEmpty: "ਕੋਈ ਬਲੈਕਲਿਸਟ ਕਲਾਇੰਟ ਨਹੀਂ",
  managerAccessRestricted: "ਵਿੱਤ ਪਹੁੰਚ ਪ੍ਰਤੀਬੰਧਿਤ। ਓਮ ਚਵਾਨ ਨਾਲ ਸੰਪਰਕ ਕਰੋ।",
  managerSection: "ਮੈਨੇਜਰ",
  managerAdd: "ਮੈਨੇਜਰ ਜੋੜੋ",
  managerName: "ਮੈਨੇਜਰ ਦਾ ਨਾਮ",
  managerEmail: "ਮੈਨੇਜਰ ਈਮੇਲ",
  managerPassword: "ਅਸਥਾਈ ਪਾਸਵਰਡ",
  managerCreated: "ਮੈਨੇਜਰ ਖਾਤਾ ਬਣ ਗਿਆ",
  managerCredentialsTitle: "ਮੈਨੇਜਰ ਲਾਗਇਨ ਵੇਰਵੇ",
  managerCredentialsSubtitle: "ਇਹ ਵੇਰਵੇ ਹੁਣ ਸੰਭਾਲ ਲਓ — ਪਾਸਵਰਡ ਬਾਅਦ ਵਿੱਚ ਵਾਪਸ ਨਹੀਂ ਮਿਲ ਸਕਦਾ",
  managerCredentialsSaved: "ਮੈਂ ਵੇਰਵੇ ਸੰਭਾਲ ਲਏ ਹਨ",
  managerLoginUrl: "ਲਾਗਇਨ URL",
  managerActivity: "ਮੈਨੇਜਰ ਗਤੀਵਿਧੀ",
  managerActivityEmpty: "ਹਾਲੇ ਕੋਈ ਗਤੀਵਿਧੀ ਦਰਜ ਨਹੀਂ",
  managerActivityViewAll: "ਸਾਰੀ ਗਤੀਵਿਧੀ ਵੇਖੋ",
  onboardingTitle: "ਸ਼ੁਰੂ ਕਰੋ",
  onboardingAccountApproved: "ਖਾਤਾ ਮਨਜ਼ੂਰ",
  onboardingKycComplete: "KYC ਪੁਸ਼ਟੀਕਰਨ ਪੂਰਾ",
  onboardingKycPending: "KYC ਪੁਸ਼ਟੀਕਰਨ ਪੂਰਾ ਕਰੋ",
  onboardingKycRejected: "KYC ਰੱਦ — ਕਿਰਪਾ ਕਰਕੇ ਮੁੜ ਜਮ੍ਹਾਂ ਕਰੋ",
  onboardingWalletFunded: "ਵਾਲਿਟ ਵਿੱਚ ਰਕਮ ਹੈ",
  onboardingWalletEmpty: "ਬੁਕਿੰਗ ਲਈ ਵਾਲਿਟ ਰਕਮ ਜੋੜੋ",
  pushEnablePrompt: "ਤੁਰੰਤ ਅੱਪਡੇਟ ਲਈ ਪੁਸ਼ ਸੂਚਨਾਵਾਂ ਚਾਲੂ ਕਰੋ",
  downloadDisputeStatement: "ਵਿਵਾਦ ਬਿਆਨ ਡਾਊਨਲੋਡ ਕਰੋ",
  downloadInvoice: "ਇਨਵੌਇਸ ਡਾਊਨਲੋਡ ਕਰੋ",
  bookAgain: "ਦੁਬਾਰਾ ਬੁੱਕ ਕਰੋ",
  machineNoLongerAvailable: "ਮਸ਼ੀਨ ਹੁਣ ਉਪਲਬਧ ਨਹੀਂ ਹੈ",
  downloadHistoryPdf: "ਇਤਿਹਾਸ PDF ਡਾਊਨਲੋਡ ਕਰੋ",
  onboardingFirstBooking: "ਆਪਣੀ ਪਹਿਲੀ ਬੁਕਿੰਗ ਕਰੋ",
  onboardingAllDone: "ਤੁਸੀਂ ਤਿਆਰ ਹੋ!",
  onboardingTrackerTitle: "ਆਨਬੋਰਡਿੰਗ ਤਰੱਕੀ",
  onboardingTrackerTarget: "ਆਨਬੋਰਡਿੰਗ ਟੀਚਾ: 48 ਘੰਟੇ",
  onboardingTrackerInProgress: "ਜਾਰੀ ਹੈ",
  onboardingTrackerActionRequired: "ਕਾਰਵਾਈ ਲੋੜੀਂਦੀ",
  onboardingTrackerComplete: "ਪੂਰਾ",
  onboardingTrackerPending: "ਬਕਾਇਆ",
  onboardingTrackerPhase1: "ਰਜਿਸਟ੍ਰੇਸ਼ਨ",
  onboardingTrackerPhase2: "KYC ਪੁਸ਼ਟੀਕਰਨ",
  onboardingTrackerPhase3: "ਮਸ਼ੀਨ ਰਜਿਸਟ੍ਰੇਸ਼ਨ",
  onboardingTrackerPhase4: "ਪਹਿਲੀ ਬੁਕਿੰਗ ਤਿਆਰ",
  onboardingTrackerHelper1: "ਮਸ਼ੀਨ ਰਜਿਸਟ੍ਰੇਸ਼ਨ ਖੋਲ੍ਹਣ ਲਈ ਆਧਾਰ + ਸੈਲਫੀ ਅਪਲੋਡ ਕਰੋ",
  onboardingTrackerHelper2: "KYC ਸਮੀਖਿਆ ਵਿੱਚ — ਆਮ ਤੌਰ ਤੇ 24 ਘੰਟਿਆਂ ਵਿੱਚ",
  onboardingTrackerHelper3: "KYC ਰੱਦ — ਦਸਤਾਵੇਜ਼ ਮੁੜ ਜਮ੍ਹਾਂ ਕਰੋ",
  onboardingTrackerHelper4: "KYC ਮਨਜ਼ੂਰ — ਆਪਣੀ ਪਹਿਲੀ ਮਸ਼ੀਨ ਜੋੜੋ",
  onboardingTrackerHelper5: "ਮਸ਼ੀਨ ਐਡਮਿਨ ਸਮੀਖਿਆ ਵਿੱਚ",
  onboardingTrackerHelper6: "ਮਸ਼ੀਨ ਲਾਈਵ — ਪਹਿਲੀ ਬੁਕਿੰਗ ਦੀ ਉਡੀਕ",
  onboardingTrackerPhaseLabel: "ਪੜਾਅ",
  alertsAndNotifications: 'ਚੇਤਾਵਨੀਆਂ ਅਤੇ ਸੂਚਨਾਵਾਂ',
  dieselFuelCostPerHour: 'ਘੰਟੇ ਦੀ ਈਂਧਨ ਲਾਗਤ',
  dieselPercentOfRate: 'ਤੁਹਾਡੀ ਘੰਟੇ ਦੀ ਦਰ ਦਾ',
  dieselPriceSaved: 'ਡੀਜ਼ਲ ਕੀਮਤ ਸੇਵ ਹੋ ਗਈ',
  dieselRateSuggestion: 'ਦਰ ਸੁਝਾਅ',
  dieselRateIncrease: 'ਡੀਜ਼ਲ ਵਧਿਆ — ਦਰ ਵਧਾਉਣ ਬਾਰੇ ਸੋਚੋ',
  dieselRateDecrease: 'ਡੀਜ਼ਲ ਘਟਿਆ — ਬੁਕਿੰਗ ਲਈ ਦਰ ਘਟਾਓ',
  dieselSuggestedRate: 'ਸੁਝਾਈ ਦਰ',
  dieselHistory: 'ਕੀਮਤ ਇਤਿਹਾਸ',
  dieselNoHistory: 'ਅਜੇ ਡੀਜ਼ਲ ਕੀਮਤ ਇਤਿਹਾਸ ਨਹੀਂ',
  dieselColDate: 'ਤਾਰੀਖ',
  dieselColPrice: 'ਕੀਮਤ/ਲੀਟਰ',
  dieselColQty: 'ਮਾਤਰਾ',
  dieselColSource: 'ਸਰੋਤ',
  dieselUploadReceipt: 'ਰਸੀਦ ਅੱਪਲੋਡ',
  dieselExtractSuccess: 'ਰਸੀਦ ਤੋਂ ਕੱਢਿਆ',
  dieselExtractFailed: 'ਕੱਢ ਨਹੀਂ ਸਕੇ — ਕਿਰਪਾ ਕਰਕੇ ਮੈਨੁਅਲ ਦਰਜ ਕਰੋ',
  applyRateSuggestion: '₹{{rate}}/ਘੰਟਾ ਲਾਗੂ ਕਰੋ',
  rateSuggestionApplied: 'ਦਰ ਸਫਲਤਾਪੂਰਵਕ ਅਪਡੇਟ ਹੋਈ',
  marketPosition: 'ਮਾਰਕੀਟ ਸਥਿਤੀ',
  marketBelowMarket: 'ਮਾਰਕੀਟ ਤੋਂ ਘੱਟ',
  marketCompetitive: 'ਮੁਕਾਬਲੇ ਵਾਲੀ',
  marketAboveMarket: 'ਮਾਰਕੀਟ ਤੋਂ ਵੱਧ',
  marketNoData: 'ਤੁਹਾਡੇ ਇਲਾਕੇ ਲਈ ਅਜੇ ਮਾਰਕੀਟ ਡੇਟਾ ਨਹੀਂ',
  marketSubmitRate: 'ਮਾਰਕੀਟ ਦਰ ਜਮ੍ਹਾਂ ਕਰੋ',
  marketCity: 'ਸ਼ਹਿਰ / ਇਲਾਕਾ',
  marketMinRate: 'ਤੁਹਾਡੇ ਇਲਾਕੇ ਵਿੱਚ ਘੱਟੋ-ਘੱਟ ਦਰ (₹/ਘੰਟਾ)',
  marketMaxRate: 'ਤੁਹਾਡੇ ਇਲਾਕੇ ਵਿੱਚ ਵੱਧ ਤੋਂ ਵੱਧ ਦਰ (₹/ਘੰਟਾ)',
  marketRateSubmitted: 'ਮਾਰਕੀਟ ਦਰ ਜਮ੍ਹਾਂ ਹੋ ਗਈ — ਧੰਨਵਾਦ!',
  marketDataPoints: '{{count}} ਜਮ੍ਹਾਂ ਤੇ ਆਧਾਰਿਤ',
  marketRange: '{{city}} ਵਿੱਚ ਮਾਰਕੀਟ',
  marketSourceLocal: '{{city}} ਇਲਾਕੇ ਦੀਆਂ ਰੇਟਾਂ ਤੇ ਆਧਾਰਿਤ',
  marketSourcePlatform: 'ਪਲੇਟਫਾਰਮ-ਵਿਆਪਕ ਰੇਟਾਂ ਤੇ ਆਧਾਰਿਤ',
  regPremiumOnboarding: 'प्रीमियम ऑनबोर्डिंग',
  regRtoNumber: 'RTO पंजीकरण संख्या *',
  regSelectType: 'प्रकार चुनें…',
  regSubmitBtn: '✅ पंजीकरण जमा करें',
  regTagNoRto: 'RTO नहीं',
  regTagRto: 'RTO',
  regYearManufacture: 'निर्माण वर्ष *',
  register: 'ਮਸ਼ੀਨ ਰਜਿਸਟ੍ਰੇਸ਼ਨ',
  registerAction: 'रजिस्टर करें',
  registerMachine: 'मशीन पंजीकरण',
  registering: 'रजिस्टर हो रहा है...',
  registrationPending: 'एडमिन 24 घंटे के भीतर आपका अकाउंट सक्रिय करेगा।',
  registrationSuccess: 'रजिस्ट्रेशन सफल!',
  remoteLockAlert: 'Teltonika GPS स्थापित होने के बाद रिमोट लॉक सक्षम होगा। DE सपोर्ट से संपर्क करें।',
  remoteLockMachine: '🔒 रिमोट लॉक मशीन',
  replaceFile: 'बदलें',
  reportText: 'रिपोर्ट',
  reports: 'ਰਿਪੋਰਟਾਂ',
  resetMethodEmail: 'Email link',
  resetMethodSms: 'SMS OTP',
  resetPasswordFailed: 'Could not reset password. Request a new link.',
  resetPasswordIntro: 'Choose a strong password with at least 8 characters.',
  resetPasswordMinLength: 'Password must be at least 8 characters.',
  resetPasswordMissingToken: 'Reset link is missing or invalid. Use Forgot password from login.',
  resetPasswordSubmit: 'Update password',
  resetPasswordSuccess: 'Password updated. Redirecting to login...',
  resetPasswordTitle: 'Set new password',
  resetPasswordUpdating: 'Updating...',
  resetText: 'रीसेट',
  retryDlqItemTitle: 'DLQ आइटम पुनः प्रयास',
  retryFailedForDlq: 'DLQ आइटम के लिए पुनः प्रयास विफल',
  retryReasonAuditPlaceholder: 'पुनः प्रयास का कारण (ऑडिट हेतु)',
  retryText: 'पुनः प्रयास',
  revenue: 'राजस्व',
  running: 'चालू',
  satisfiedNo: 'संतुष्ट नहीं',
  satisfiedYes: 'हाँ, संतुष्ट',
  save: 'ਸੇਵ ਕਰੋ',
  scanToPay: 'भुगतान के लिए स्कैन करें',
  scheduleColFeedback: 'फीडबैक',
  scheduleColQty: 'Qty',
  scheduleColTotal: 'कुल',
  scheduleColType: 'प्रकार',
  securitySignalsTitle: 'सुरक्षा संकेत',
  selectBook: 'ਇਹ ਮਸ਼ੀਨ ਬੁੱਕ ਕਰੋ →',
  selectCalc: '📋 ਚੁਣੋ & ਲਾਗਤ ਦੇਖੋ →',
  selectFile: 'ਫਾਈਲ ਚੁਣੋ',
  selectMachineFirst: 'ਪਹਿਲਾਂ ਮਸ਼ੀਨ ਚੁਣੋ',
  selectQty: 'ਮਾਤਰਾ ਚੁਣੋ',
  selectRole: 'ਭੂਮਿਕਾ ਚੁਣੋ',
  selectedMachineText: 'चयनित मशीन',
  send: 'ਭੇਜੋ',
  sendEmail: 'ਈਮੇਲ ਭੇਜੋ',
  sendWhatsapp: 'WhatsApp ਤੇ ਭੇਜੋ',
  settlements: 'निपटान',
  show: 'दिखाएं',
  signIn: 'ਸਾਈਨ ਇਨ ਕਰੋ',
  signingIn: 'ਲੌਗਿਨ ਹੋ ਰਿਹਾ ਹੈ...',
  signupCompanyName: 'कंपनी का नाम',
  signupContactName: 'संपर्क नाम',
  signupCreatePassword: 'पासवर्ड बनाएं',
  signupReenterPassword: 'पासवर्ड दोबारा दर्ज करें',
  signupSectionCompany: 'कंपनी',
  signupSectionContact: 'आपका विवरण',
  signupSectionSecurity: 'सुरक्षा',
  sinceExcellence: '2011 से · 15 वर्ष उत्कृष्टता',
  sinceLabel: 'ਤੋਂ',
  sloBreachRisk: 'SLO breach जोखिम',
  sloHealthy: 'SLO स्वस्थ',
  speed: 'ਗਤੀ',
  staleText: 'पुराना',
  status: 'ਸਥਿਤੀ',
  statusCancelled: 'रद्द',
  bookingClosed: 'ਬੰਦ',
  sectionNew: 'ਨਵਾਂ',
  sectionAccepted: 'ਸਵੀਕਾਰ',
  sectionActive: 'ਸਰਗਰਮ',
  sectionDispatched: 'ਡਿਸਪੈਚ',
  sectionCompleting: 'ਪੂਰਾ ਹੋ ਰਿਹਾ',
  sectionDisputed: 'ਵਿਵਾਦ',
  sectionCompleted: 'ਪੂਰਾ',
  sectionClosed: 'ਬੰਦ',
  statusCompleted: 'पूर्ण',
  stopped: 'बंद',
  submit: 'ਜਮ੍ਹਾਂ ਕਰੋ',
  submitOperatorFeedback: 'फीडबैक भेजें',
  submittedRegistrations: 'जमा पंजीकरण',
  support: 'ਸਹਾਇਤਾ',
  supportPolicyBooking: 'केवल वॉलेट अग्रिम। साइट पर नकद नहीं।',
  supportPolicyCancellation: '1 घंटे का जुर्माना; शेष वॉलेट में।',
  supportPolicyContact: 'केवल DE सपोर्ट — सीधा ऑपरेटर संपर्क वर्जित।',
  supportPolicyGst: 'सभी इनवॉइस पर 18% GST; रिपोर्ट टैब से डाउनलोड।',
  supportPolicyHours: 'सोम–शनि, 9–7 IST',
  tableAtt: 'उप',
  tableChange: 'बदलाव',
  tableDay: 'दिन',
  tableEnd: 'समाप्त',
  tableHrs: 'घं',
  tableId: 'आईडी',
  tableIn: 'इन',
  tableLevel: 'स्तर',
  tableMonth: 'महीना',
  tableNote: 'नोट',
  tableOut: 'आउट',
  tableStart: 'शुरू',
  tagline: 'ਬੁਨਿਆਦੀ ਢਾਂਚੇ ਦਾ ਸੋਨੇ ਦਾ ਮਿਆਰ',
  tax: 'ਟੈਕਸ',
  tdsGstTcs: 'TDS 2% + GST TCS 1%',
  tdsTcs: 'TDS+TCS',
  termCommission: 'Development Express कमीशन: सकल बिलिंग का 15%',
  termFuel: 'मशीन में हमेशा 40%+ ईंधन रखें',
  termGps: 'GPS (Teltonika) अनिवार्य — DE द्वारा स्थापित',
  termGstTcs: 'GST TCS: GST नियमों के अनुसार 1%',
  termNoDirectContact: 'सीधा क्लाइंट संपर्क = तत्काल अनुबंध समाप्ति',
  termPaymentDays: 'क्लाइंट निपटान के 3 कार्य दिवसों में भुगतान',
  termTds: 'TDS कटौती: आयकर अधिनियम के अनुसार 2%',
  threeWorkingDays: '3 कार्य दिवस',
  timeLabel: 'समय',
  todayText: 'आज',
  topSourceIp: 'शीर्ष स्रोत IP',
  total: 'ਕੁੱਲ',
  totalAdvanceLabel: 'अग्रिम भुगतान',
  totalBookingsText: 'कुल बुकिंग',
  totalMachines: 'ਕੁੱਲ ਮਸ਼ੀਨਾਂ',
  totalSpent: 'कुल खर्च',
  tracking: 'GPS ਟਰੈਕਿੰਗ',
  transactionHistoryTitle: 'लेनदेन इतिहास',
  transactions: 'ਲੈਣ-ਦੇਣ ਇਤਿਹਾਸ',
  trustStatCompliant: 'अनुपालन',
  trustStatMachines: 'मशीन',
  trustStatRating: 'रेटिंग',
  txnDescription: 'विवरण',
  type: 'ਕਿਸਮ',
  understood: '✅ ਸਮਝ ਗਿਆ — ਪਲੇਟਫਾਰਮ ਵਰਤਾਂਗਾ',
  understoodAction: 'समझ गया',
  unknownText: 'अज्ञात',
  updateFuel: 'फ्यूल अपडेट करें',
  updateText: 'अपडेट करें',
  upiAppsHint: 'PhonePe | GPay | Paytm | BHIM',
  uploadFile: 'अपलोड',
  valEmail: 'वैध ईमेल आवश्यक',
  valMachineName: 'मशीन नाम / मॉडल आवश्यक',
  valMachineType: 'उपकरण श्रेणी चुनें',
  valMobility: 'व्हील्ड या क्रॉलर उपकरण प्रकार चुनें',
  valOwnerName: 'मालिक का नाम आवश्यक',
  valPdiChecks: 'सभी आवश्यक जांचें पुष्टि करें',
  valPdiRequired: 'PDI पुष्टि आवश्यक',
  valPhone: 'वैध फ़ोन नंबर आवश्यक',
  valRto: 'व्हील्ड मशीनों के लिए RTO नंबर आवश्यक',
  valUploadMissing: 'अपलोड करें: {docs}',
  valYear: 'वैध वर्ष (YYYY) आवश्यक',
  viewMachines: '→ ਮਸ਼ੀਨਾਂ ਦੇਖੋ',
  wallet: 'ਵਾਲੇਟ',
  walletBalance: 'ਵਾਲੇਟ ਬੈਲੈਂਸ',
  walletCredit: 'ਵਾਲੇਟ ਕ੍ਰੈਡਿਟ',
  walletDebit: 'वॉलेट डेबिट',
  walletDeduct: 'ਅਡਵਾਂਸ ਵਾਲੇਟ ਤੋਂ ਕੱਟਿਆ ਜਾਵੇਗਾ · ਨਕਦ ਨਹੀਂ · GST ਆਟੋ ਬਣੇਗਾ',
  walletInsufficient: '❌ ਨਾਕਾਫ਼ੀ',
  walletLowRecharge: 'वॉलेट शेष कम — अगली बुकिंग से पहले रिचार्ज करें',
  walletOnly: 'ਸਿਰਫ਼ ਵਾਲੇਟ · ਨਕਦ ਸਵੀਕਾਰ ਨਹੀਂ',
  walletOnlyPolicyDesc: 'सभी लेनदेन केवल वॉलेट से। नकद स्वीकार नहीं।',
  walletOnlyPolicyTitle: 'केवल वॉलेट नीति',
  walletRechargeTitle: 'वॉलेट रिचार्ज',
  walletSufficient: '✅ ਅੱਗੇ ਵਧੋ',
  weeks: 'ਹਫ਼ਤੇ',
  whatsapp: 'WhatsApp',
  wksUnit: 'सप्ताह',
  year: 'ਸਾਲ',
  yearsExperience: '{n} वर्ष',
  yourMessage: 'ਆਪਣਾ ਸਵਾਲ ਜਾਂ ਸਮੱਸਿਆ ਲਿਖੋ...',
  // --- Recent feature strings ---
  retryLabel: 'ਦੁਬਾਰਾ ਕੋਸ਼ਿਸ਼ ਕਰੋ',
  payrollPreview: 'ਤਨਖਾਹ ਪੂਰਵਾਵਲੋਕਨ',
  payrollRun: 'ਤਨਖਾਹ ਚਲਾਓ',
  payrollAlreadyRun: 'ਇਸ ਮਹੀਨੇ ਲਈ ਤਨਖਾਹ ਪਹਿਲਾਂ ਹੀ ਚਲ ਚੁਕੀ ਹੈ',
  payrollGross: 'ਕੁੱਲ ਦੇਣਯੋਗ',
  payrollNet: 'ਸ਼ੁੱਧ ਦੇਣਯੋਗ',
  payrollAdvanceDeducted: 'ਐਡਵਾਂਸ ਕਟੌਤੀ',
  payrollRunSuccess: 'ਤਨਖਾਹ ਸਫਲਤਾਪੂਰਵਕ ਚਲੀ',
  payrollNoAmount: 'ਇਸ ਮਹੀਨੇ ਲਈ ਦੇਣਯੋਗ ਰਕਮ ਨਹੀਂ',
  payrollMonth: 'ਤਨਖਾਹ ਮਹੀਨਾ',
  exportPayrollCsv: 'ਤਨਖਾਹ CSV ਨਿਰਯਾਤ',
  payrollExportMonth: 'ਤਨਖਾਹ ਨਿਰਯਾਤ ਮਹੀਨਾ',
  payrollDailyRate: 'ਰੋਜ਼ਾਨਾ ਦਰ',
  payrollHistory: 'ਤਨਖਾਹ ਇਤਿਹਾਸ',
  payrollNoHistory: 'ਅਜੇ ਤੱਕ ਕੋਈ ਤਨਖਾਹ ਨਹੀਂ ਚੱਲੀ',
  payrollColMonth: 'ਮਹੀਨਾ',
  payrollColGross: 'ਕੁੱਲ',
  payrollColDeduction: 'ਐਡਵਾਂਸ ਕਟੌਤੀ',
  payrollColNet: 'ਨੈੱਟ ਤਨਖਾਹ',
  payrollColDate: 'ਤਾਰੀਖ',
  downloadPayslip: 'ਪੇ ਸਲਿਪ ਡਾਊਨਲੋਡ',
  payslipTitle: 'ਮਹੀਨਾਵਾਰ ਪੇ ਸਲਿਪ',
  payslipEarnings: 'ਕਮਾਈ',
  payslipDeductions: 'ਕਟੌਤੀਆਂ',
  payslipDaysWorked: 'ਕੰਮ ਦੇ ਦਿਨ',
  payslipGeneratedBy: 'Development Express ਦੁਆਰਾ ਤਿਆਰ',
  operatorPayrollTitle: 'ਮੇਰੀ ਤਨਖਾਹ',
  payrollMonthlySalary: 'ਮਹੀਨਾਵਾਰੀ ਤਨਖਾਹ',
  payrollCurrentMonth: 'ਮੌਜੂਦਾ ਮਹੀਨਾ',
  payrollPreviousMonth: 'ਪਿਛਲਾ ਮਹੀਨਾ',
  ownerAttendanceTitle: 'ਹਾਜ਼ਰੀ',
  ownerAttendanceEdit: 'ਸੰਪਾਦਨ',
  ownerAttendanceSave: 'ਸੇਵ',
  ownerAttendanceNoRecords: 'ਇਸ ਮਹੀਨੇ ਲਈ ਹਾਜ਼ਰੀ ਰਿਕਾਰਡ ਨਹੀਂ',
  ownerAttendanceOverrideSuccess: 'ਹਾਜ਼ਰੀ ਅਪਡੇਟ ਹੋ ਗਈ',
  ownerSalaryUpdated: 'ਤਨਖਾਹ ਸਫਲਤਾਪੂਰਵਕ ਅਪਡੇਟ ਹੋ ਗਈ',
  ownerSalaryEditBtn: 'ਤਨਖਾਹ ਸੰਪਾਦਨ',
  ownerSalaryNotSet: 'ਤਨਖਾਹ ਸੈੱਟ ਨਹੀਂ — ਪੇਰੋਲ ਲਈ ਤਨਖਾਹ ਸੈੱਟ ਕਰੋ',
  duration: "ਮਿਆਦ",
  durationLabel: 'ਮਿਆਦ',
  plQuotaLabel: 'PL ਕੋਟਾ',
  plUsed: 'ਵਰਤੀ',
  plAllowed: 'ਮਨਜ਼ੂਰ',
  plRemaining: 'ਬਾਕੀ',
  plQuotaUpdated: 'PL ਕੋਟਾ ਅਪਡੇਟ',
  plQuotaExhausted: 'PL ਕੋਟਾ ਖਤਮ — ਬਿਨਾ ਤਨਖਾਹ ਵਾਲੀ ਛੁੱਟੀ ਵਜੋਂ ਦਰਜ',
  plRemainingLabel: 'ਬਾਕੀ PL',
  noAttendanceRecords: 'ਅਜੇ ਤੱਕ ਹਾਜ਼ਰੀ ਰਿਕਾਰਡ ਨਹੀਂ',
  noFuelLogs: 'ਅਜੇ ਤੱਕ ਇੰਧਨ ਲਾਗ ਨਹੀਂ',
  noIssuesYet: 'ਅਜੇ ਤੱਕ ਕੋਈ ਸਮੱਸਿਆ ਦਰਜ ਨਹੀਂ',
  failedToLoad: 'ਡੇਟਾ ਲੋਡ ਕਰਨਾ ਅਸਫਲ',
  failedToLoadReport: 'ਰਿਪੋਰਟ ਲੋਡ ਕਰਨਾ ਅਸਫਲ',
  failedToLoadIssues: 'ਸਮੱਸਿਆਵਾਂ ਲੋਡ ਕਰਨਾ ਅਸਫਲ',
  failedToLoadAlerts: 'ਅਲਰਟ ਲੋਡ ਕਰਨਾ ਅਸਫਲ',
  noRecordsMonth: 'ਇਸ ਮਹੀਨੇ ਲਈ ਰਿਕਾਰਡ ਨਹੀਂ',
  underReview: 'ਸਮੀਖਿਆ ਅਧੀਨ',
  issueResolved: 'ਹੱਲ ਹੋ ਗਿਆ',
  presentDaysLabel: 'ਹਾਜ਼ਰੀ ਦਿਨ',
  halfDaysLabel: 'ਅੱਧੇ ਦਿਨ',
  absentDaysLabel: 'ਗੈਰਹਾਜ਼ਰੀ ਦਿਨ',
  totalHmrLabel: 'ਕੁੱਲ HMR',
  noActiveBookingIdle: 'ਕੋਈ ਸਕ੍ਰਿਆ ਬੁਕਿੰਗ ਨਹੀਂ — ਮਸ਼ੀਨ ਨਿਸ਼ਕ੍ਰਿਆ',
  siteLocationNotCaptured: 'ਸਾਈਟ ਸਥਾਨ ਦਰਜ ਨਹੀਂ',
  siteLocationNotAvailable: 'ਸਾਈਟ ਸਥਾਨ ਉਪਲਬਧ ਨਹੀਂ',
  bookingRefLabel: 'ਬੁਕਿੰਗ Ref',
  alertPendingBookings: 'ਬਾਕੀ ਬੁਕਿੰਗ',
  alertPendingPayouts: 'ਬਾਕੀ ਭੁਗਤਾਨ',
  alertLowFuel: 'ਘੱਟ ਇੰਧਨ',
  alertOpenIssues: 'ਖੁੱਲ੍ਹੀਆਂ ਸਮੱਸਿਆਵਾਂ',
  noMachineRunning: 'ਫਿਲਹਾਲ ਕੋਈ ਮਸ਼ੀਨ ਚੱਲ ਨਹੀਂ ਰਹੀ',
  trackingEmptyHint: 'ਮਸ਼ੀਨ ਭੇਜਣ ਤੋਂ ਬਾਅਦ ਤੁਹਾਡੀ ਸਕ੍ਰਿਆ ਬੁਕਿੰਗ ਇੱਥੇ ਦਿਖੇਗੀ।',
  trackingUpdatedEvery5s: 'ਹਰ 5 ਸਕਿੰਟ ਵਿੱਚ ਅਪਡੇਟ',
  fuelLastOperatorUpdate: '(ਆਪਰੇਟਰ ਦਾ ਆਖਰੀ ਅਪਡੇਟ)',
  alertExtensionPending: 'ਬੁਕਿੰਗ ਐਕਸਟੈਨਸ਼ਨ ਬਾਕੀ',
  alertConfirmCompletion: 'ਕ੍ਰਿਪਾ ਕਰਕੇ ਕੰਮ ਪੂਰਨਤਾ ਦੀ ਪੁਸ਼ਟੀ ਕਰੋ',
  alertWalletCredited: 'ਵਾਲਿਟ ਵਿੱਚ ਜੋੜਿਆ ਗਿਆ',
  alertFeedbackRequest: 'ਕੰਮ ਪੂਰਾ — ਆਪਣੀ ਰਾਏ ਸਾਂਝੀ ਕਰੋ',
  noLogsYet: 'ਅਜੇ ਤੱਕ ਕੋਈ ਗਤਿਵਿਧੀ ਦਰਜ ਨਹੀਂ',
  todayActivityLog: 'ਅੱਜ ਦੀ ਗਤਿਵਿਧੀ ਲੌਗ',
  machineLogSubtitle: 'ਇੰਧਨ, ਹਾਜ਼ਰੀ, ਮੁੱਦੇ — ਸਥਾਨਕ ਸੈਸ਼ਨ ਲੌਗ',
  timerPaused: 'Timer ਰੋਕਿਆ ਗਿਆ',
  liveBookingTitle: 'ਲਾਈਵ ਬੁਕਿੰਗ',
  machineLogTimerHint: 'Timer Admin ਸ਼ੁਰੂ ਕਰਦਾ ਹੈ। ਹੇਠਾਂ ਆਪਣਾ ਅਸਲੀ ਕੰਮ ਦਾ ਸਮਾਂ ਦਰਜ ਕਰੋ — ਪੂਰਾ ਹੋਣ ਤੇ Mark Work Complete ਕਲਿਕ ਕਰੋ।',
  resumeTimer: 'Resume Timer',
  pauseTimer: 'Pause Timer',
  attendanceLogNote: 'ਹਾਜ਼ਰੀ',
  ownerAlertBookingPending: 'ਨਵੀਂ ਬੁਕਿੰਗ ਤੁਹਾਡੀ ਮਨਜ਼ੂਰੀ ਲਈ ਬਾਕੀ —',
  ownerAlertBookingHours: 'ਘੰਟੇ',
  ownerAlertPayoutPending: '₹{{amount}} ਦੀ ਭੁਗਤਾਨ ਟ੍ਰਾਂਸਫਰ ਲਈ ਬਾਕੀ',
  ownerAlertFuelLow: 'ਇੰਧਨ ਘੱਟ',
  ownerAlertFuelRemaining: 'ਬਾਕੀ',
  ownerAlertIssue: 'ਮੁੱਦਾ ਦਰਜ',
  iotGpsDevicesActive: 'GPS ਡਿਵਾਈਸ ਸਕ੍ਰਿਆ',
  iotDashcamsOnline: 'ਡੈਸ਼ਕੈਮ ਔਨਲਾਈਨ',
  iotFuelSensorsActive: 'ਫਿਊਲ ਸੈਂਸਰ ਸਕ੍ਰਿਆ',
  iotMachinesLocked: 'ਮਸ਼ੀਨਾਂ ਲਾਕ',
  iotDeviceStatus: 'IoT ਡਿਵਾਈਸ ਸਥਿਤੀ',
  iotColMachine: 'ਮਸ਼ੀਨ',
  iotColGps: 'GPS',
  iotColLocation: 'ਸਥਾਨ',
  iotColFuel: 'ਫਿਊਲ %',
  iotColDashcam: 'ਡੈਸ਼ਕੈਮ',
  iotColIgnition: 'ਇਗਨੀਸ਼ਨ',
  iotColAction: 'ਕਾਰਵਾਈ',
  iotStatusOnline: 'ਔਨਲਾਈਨ',
  iotStatusNotConnected: 'ਕਨੈਕਟ ਨਹੀਂ',
  iotStatusLive: 'ਲਾਈਵ',
  iotStatusOn: 'ON',
  iotStatusOff: 'OFF',
  iotLockBtn: 'ਲਾਕ',
  iotNotConnectedBanner: 'IoT ਹਾਰਡਵੇਅਰ ਅਜੇ ਇੰਸਟਾਲ ਨਹੀਂ ਹੈ। Teltonika ਡਿਵਾਈਸ ਇੰਸਟਾਲੇਸ਼ਨ ਤੋਂ ਬਾਅਦ GPS, ਡੈਸ਼ਕੈਮ ਅਤੇ ਰਿਮੋਟ ਲਾਕ ਸੁਵਿਧਾਵਾਂ ਉਪਲਬਧ ਹੋਣਗੀਆਂ।',
  fuelUpdateTitle: 'ਫਿਊਲ ਅਪਡੇਟ',
  fuelSensorAccuracyNote: 'ਆਪਰੇਟਰ ਦੁਆਰਾ ਦਰਜ ਫਿਊਲ ਪੱਧਰ · ਮੈਨੂਅਲ ਐਂਟਰੀ',
  bookingsTab: 'ਬੁਕਿੰਗਾਂ',
  unknownLabel: 'ਅਣਪਛਾਤਾ',
  naLabel: 'N/A',
  baseLabel: 'ਅਧਾਰ',
  qtyLabel: 'ਮਾਤਰਾ',
  actualHrsLabel: 'ਅਸਲੀ ਘੰਟੇ',
  auditStatTotal: 'ਕੁੱਲ',
  auditStatSecurity: 'ਸੁਰੱਖਿਆ',
  auditStatActors: 'ਕਰਤਾ',
  auditStatAdmin: 'Admin',
  auditStatNonAdmin: 'Non-Admin',
  kycDocLicense: 'ਲਾਇਸੈਂਸ',
  kycDocAadhaarFront: 'Aadhaar ਅਗਲਾ',
  kycDocAadhaarBack: 'Aadhaar ਪਿੱਛੇ',
  kycDocPoliceVerification: 'ਪੁਲਿਸ ਤਸਦੀਕ',
  kycVerification: 'KYC ਤਸਦੀਕ',
  kycNotSubmitted: 'KYC ਜਮਾ ਨਹੀਂ',
  kycUnderReview: 'KYC ਸਮੀਖਿਆ ਅਧੀਨ',
  kycVerified: 'KYC ਤਸਦੀਕਸ਼ੁਦਾ',
  kycRejected: 'KYC ਰੱਦ',
  kycAadhaarFront: 'Aadhaar ਅਗਲਾ',
  kycAadhaarBack: 'Aadhaar ਪਿੱਛੇ',
  kycSelfie: 'ਸੈਲਫੀ',
  kycSubmitBtn: 'KYC ਦਸਤਾਵੇਜ਼ ਜਮ੍ਹਾਂ ਕਰੋ',
  kycSubmitSuccess: 'ਦਸਤਾਵੇਜ਼ ਜਮ੍ਹਾਂ — ਸਮੀਖਿਆ ਅਧੀਨ',
  kycResubmit: 'ਦਸਤਾਵੇਜ਼ ਦੁਬਾਰਾ ਜਮ੍ਹਾਂ ਕਰੋ',
  adminKycTitle: 'ਕਲਾਇੰਟ KYC ਸਮੀਖਿਆ',
  adminKycAllFilter: 'ਸਭ',
  adminKycNoSubmissions: 'ਅਜੇ KYC ਜਮ੍ਹਾਂ ਨਹੀਂ',
  adminOwnerKycTitle: 'ਮਾਲਕ KYC ਸਮੀਖਿਆ',
  adminOwnerKycNoSubmissions: 'ਅਜੇ ਕੋਈ ਮਾਲਕ KYC ਜਮ੍ਹਾਂ ਨਹੀਂ',
  adminOperatorKycTitle: 'ਆਪਰੇਟਰ KYC ਸਮੀਖਿਆ',
  adminOperatorKycNoSubmissions: 'ਅਜੇ ਕੋਈ ਆਪਰੇਟਰ KYC ਜਮ੍ਹਾਂ ਨਹੀਂ',
  kycRejectedWarning: 'ਤੁਹਾਡਾ KYC ਰੱਦ ਕੀਤਾ ਗਿਆ। ਕਿਰਪਾ ਕਰਕੇ ਦਸਤਾਵੇਜ਼ ਦੁਬਾਰਾ ਜਮ੍ਹਾਂ ਕਰੋ।',
  kycNotSubmittedHint: 'ਭਰੋਸੇਮੰਦ ਅਨੁਭਵ ਲਈ KYC ਪੂਰਾ ਕਰੋ।',
  kycPendingHint: 'ਤੁਹਾਡਾ KYC ਸਮੀਖਿਆ ਅਧੀਨ ਹੈ।',
  kycGoToTab: 'KYC ਤੇ ਜਾਓ',
  adminKycApproveBtn: 'ਮਨਜ਼ੂਰ',
  adminKycRejectBtn: 'ਰੱਦ',
  adminKycViewDocs: 'ਦਸਤਾਵੇਜ਼ ਦੇਖੋ',
  adminKycRejectReason: 'ਰੱਦ ਕਰਨ ਦਾ ਕਾਰਨ',
  adminKycRereviewBtn: 'ਦੁਬਾਰਾ ਸਮੀਖਿਆ',
  kycPan: 'PAN ਕਾਰਡ',
  kycOwnerSubmitSuccess: 'ਦਸਤਾਵੇਜ਼ ਜਮ੍ਹਾਂ — ਤੁਹਾਡਾ KYC ਸਮੀਖਿਆ ਅਧੀਨ',
  kycLicense: 'ਡਰਾਈਵਿੰਗ ਲਾਇਸੈਂਸ',
  kycPoliceVerification: 'ਪੁਲਿਸ ਤਸਦੀਕ',
  kycOperatorSubmitSuccess: 'ਦਸਤਾਵੇਜ਼ ਜਮ੍ਹਾਂ — ਤੁਹਾਡਾ KYC ਸਮੀਖਿਆ ਅਧੀਨ',
  operatorKycRejectedAssign: 'ਇਸ ਆਪਰੇਟਰ ਦਾ KYC ਰੱਦ ਕੀਤਾ ਗਿਆ — ਦੁਬਾਰਾ ਮਨਜ਼ੂਰ ਹੋਣ ਤੱਕ ਉਹਨਾਂ ਨੂੰ ਅਸਾਈਨ ਨਹੀਂ ਕੀਤਾ ਜਾ ਸਕਦਾ।',
  operatorsColOperator: 'ਆਪਰੇਟਰ',
  operatorsColEmail: 'ਈਮੇਲ',
  operatorsColPhone: 'ਫੋਨ',
  operatorsColDocuments: 'ਦਸਤਾਵੇਜ਼',
  operatorsColStatus: 'ਸਥਿਤੀ',
  operatorsDocumentsBtn: 'ਦਸਤਾਵੇਜ਼ ({{count}})',
  operatorsNoResults: 'ਕੋਈ ਆਪਰੇਟਰ ਨਹੀਂ ਮਿਲਿਆ',
  operatorsAllTitle: 'ਸਾਰੇ ਆਪਰੇਟਰ ({{count}})',
  operatorsKycDialogDesc: 'KYC ਦਸਤਾਵੇਜ਼',
  bookingsCountLabel: '{{count}} ਬੁਕਿੰਗ',
  complianceDates: 'ਪਾਲਣਾ ਤਾਰੀਖਾਂ',
  complianceInsurance: 'ਬੀਮਾ',
  complianceRcBook: 'RC ਬੁੱਕ',
  compliancePuc: 'PUC',
  complianceNotSet: 'ਸੈੱਟ ਨਹੀਂ',
  complianceExpired: 'ਮਿਆਦ ਖਤਮ',
  complianceExpiringSoon: 'ਜਲਦੀ ਮਿਆਦ ਖਤਮ',
  complianceExpiringCritical: '7 ਦਿਨਾਂ ਵਿੱਚ ਮਿਆਦ',
  complianceValid: 'ਵੈਧ',
  complianceUpdateBtn: 'ਪਾਲਣਾ ਤਾਰੀਖਾਂ ਅਪਡੇਟ ਕਰੋ',
  complianceSaveBtn: 'ਸੇਵ',
  complianceAlertsTitle: 'ਪਾਲਣਾ ਅਲਰਟ',
  complianceAllCompliant: 'ਸਾਰੀਆਂ ਮਸ਼ੀਨਾਂ ਪਾਲਣਾ ਵਿੱਚ ✅',
  complianceColMachine: 'ਮਸ਼ੀਨ',
  complianceColOwner: 'ਮਾਲਕ',
  complianceColInsurance: 'ਬੀਮਾ',
  complianceColRcBook: 'RC ਬੁੱਕ',
  complianceColPuc: 'PUC',
  complianceNa: 'N/A',
  complianceStartDate: 'ਸ਼ੁਰੂਆਤ ਦੀ ਤਾਰੀਖ',
  complianceEndDate: 'ਸਮਾਪਤੀ ਤਾਰੀਖ',
  complianceExtractBtn: 'ਤਾਰੀਖਾਂ ਆਪਣੇ ਆਪ ਭਰਨ ਲਈ ਦਸਤਾਵੇਜ਼ ਅਪਲੋਡ ਕਰੋ',
  complianceExtractSuccess: 'ਤਾਰੀਖਾਂ ਕੱਢੀਆਂ ਗਈਆਂ — ਸੇਵ ਕਰਨ ਤੋਂ ਪਹਿਲਾਂ ਜਾਂਚ ਕਰੋ',
  complianceExtractError: 'ਤਾਰੀਖਾਂ ਕੱਢ ਨਹੀਂ ਸਕੇ — ਕਿਰਪਾ ਕਰਕੇ ਹੱਥੀਂ ਦਰਜ ਕਰੋ',
  complianceExtracting: 'ਦਸਤਾਵੇਜ਼ ਪੜ੍ਹਿਆ ਜਾ ਰਿਹਾ ਹੈ...',
  serviceHistory: 'ਸੇਵਾ ਇਤਿਹਾਸ',
  serviceLastService: 'ਆਖਰੀ ਸੇਵਾ',
  serviceNoRecords: 'ਅਜੇ ਕੋਈ ਸੇਵਾ ਰਿਕਾਰਡ ਨਹੀਂ',
  serviceNextDue: 'ਅਗਲੀ ਸੇਵਾ ਬਕਾਇਆ',
  serviceNextHmr: 'ਅਗਲੀ ਸੇਵਾ ਤੇ',
  serviceAddLog: 'ਸੇਵਾ ਲਾਗ ਜੋੜੋ',
  serviceDate: 'ਸੇਵਾ ਤਾਰੀਖ',
  serviceType: 'ਸੇਵਾ ਕਿਸਮ',
  serviceHmr: 'ਸੇਵਾ HMR',
  serviceNextDate: 'ਅਗਲੀ ਸੇਵਾ ਤਾਰੀਖ',
  serviceWorkDone: 'ਕੀਤਾ ਕੰਮ',
  serviceNotes: 'ਨੋਟ',
  serviceTypeRoutine: 'ਰੁਟੀਨ',
  serviceTypeMajor: 'ਮੁੱਖ',
  serviceTypeBreakdown: 'ਖਰਾਬੀ',
  serviceTypePdi: 'PDI',
  serviceTypeOther: 'ਹੋਰ',
  serviceOverdue: 'ਮਿਆਦ ਪੁੱਗੀ',
  serviceDueSoon: 'ਜਲਦੀ ਬਕਾਇਆ',
  fleetAnalytics: 'ਫਲੀਟ ਵਿਸ਼ਲੇਸ਼ਣ',
  analyticsRevenue: 'ਕੁੱਲ ਆਮਦਨ',
  analyticsBookings: 'ਕੁੱਲ ਬੁਕਿੰਗ',
  analyticsHours: 'ਕੁੱਲ ਘੰਟੇ',
  analyticsActiveMachines: 'ਸਰਗਰਮ ਮਸ਼ੀਨਾਂ',
  analyticsMonthlyTrend: 'ਮਹੀਨਾਵਾਰ ਆਮਦਨ ਰੁਝਾਨ',
  analyticsMachineTable: 'ਮਸ਼ੀਨ ਅਨੁਸਾਰ ਆਮਦਨ',
  analyticsNoData: 'ਇਸ ਅਵਧੀ ਵਿੱਚ ਕੋਈ ਪੂਰੀ ਬੁਕਿੰਗ ਨਹੀਂ',
  analyticsLastBooking: 'ਆਖਰੀ ਬੁਕਿੰਗ',
  analytics3Months: '3 ਮਹੀਨੇ',
  analytics6Months: '6 ਮਹੀਨੇ',
  analytics12Months: '12 ਮਹੀਨੇ',
  adminAnalytics: 'ਵਿਸ਼ਲੇਸ਼ਣ',
  adminFleetTitle: 'ਫਲੀਟ ਵਿਸ਼ਲੇਸ਼ਣ',
  adminFleetPlatformRevenue: 'ਪਲੇਟਫਾਰਮ ਆਮਦਨ',
  adminFleetActiveOwners: 'ਸਰਗਰਮ ਮਾਲਕ',
  adminFleetOwnerCol: 'ਮਾਲਕ',
  adminFleetMonthlyTrend: 'ਮਾਸਿਕ ਆਮਦਨ ਰੁਝਾਨ',
  adminFleetMachineTable: 'ਮਸ਼ੀਨ ਅਨੁਸਾਰ ਆਮਦਨ',
  adminFleetNoData: 'ਇਸ ਅਵਧੀ ਵਿੱਚ ਕੋਈ ਪੂਰੀ ਬੁਕਿੰਗ ਨਹੀਂ',
  adminFinancialIntelligence: 'ਮਸ਼ੀਨ ਵਿੱਤੀ ਜਾਣਕਾਰੀ',
  adminTotalInvested: 'ਕੁੱਲ ਨਿਵੇਸ਼',
  adminTotalEarned: 'ਕੁੱਲ ਕਮਾਈ',
  adminAvgRecovery: 'ਔਸਤ ਵਸੂਲੀ',
  adminBreakEvenRate: 'ਬ੍ਰੇਕ-ਈਵਨ ਦਰ',
  adminProfitMargin: 'ਲਾਭ ਮਾਰਜਿਨ',
  adminNoFinancialData: 'ਅਜੇ ਤੱਕ ਵਿੱਤੀ ਡੇਟਾ ਵਾਲੀਆਂ ਮਸ਼ੀਨਾਂ ਨਹੀਂ',
  adminMachineDetail: 'ਮਸ਼ੀਨ ਵੇਰਵਾ',
  adminCallOwner: 'ਮਾਲਕ ਨੂੰ ਕਾਲ ਕਰੋ',
  adminWhatsappOwner: 'WhatsApp ਮਾਲਕ',
  adminMarketRates: 'ਮਾਰਕੀਟ ਰੇਟ ਜਮ੍ਹਾਂ',
  adminMarketRateDelete: 'ਹਟਾਓ',
  adminMarketRateDeleteConfirm: 'ਕੀ ਇਹ ਮਾਰਕੀਟ ਰੇਟ ਜਮ੍ਹਾਂ ਹਟਾਉਣੀ ਹੈ?',
  adminMarketRateDeleted: 'ਮਾਰਕੀਟ ਰੇਟ ਹਟਾ ਦਿੱਤੀ ਗਈ',
  adminMarketRateNoData: 'ਅਜੇ ਤੱਕ ਕੋਈ ਮਾਰਕੀਟ ਰੇਟ ਜਮ੍ਹਾਂ ਨਹੀਂ',
  marketRateApprove: 'ਮਨਜ਼ੂਰ ਕਰੋ',
  marketRateReject: 'ਰੱਦ ਕਰੋ',
  marketRateApproved: 'ਮਨਜ਼ੂਰ',
  marketRateRejected: 'ਰੱਦ',
  marketRatePending: 'ਲੰਬਿਤ',
  marketRateReviewed: 'ਮਾਰਕੀਟ ਰੇਟ ਦੀ ਸਮੀਖਿਆ ਹੋ ਗਈ',
  marketRatePendingReview: 'ਤੁਹਾਡੀ ਰੇਟ ਜਮ੍ਹਾਂ ਹੋ ਗਈ ਹੈ ਅਤੇ ਐਡਮਿਨ ਸਮੀਖਿਆ ਲਈ ਲੰਬਿਤ ਹੈ।',
  marketRateEditApprove: 'ਸੋਧੋ ਅਤੇ ਮਨਜ਼ੂਰ ਕਰੋ',
  marketRateEditMin: 'ਸੁਧਾਰੀ ਘੱਟੋ-ਘੱਟ ਰੇਟ (₹/ਘੰਟਾ)',
  marketRateEditMax: 'ਸੁਧਾਰੀ ਵੱਧ ਤੋਂ ਵੱਧ ਰੇਟ (₹/ਘੰਟਾ)',
  adminPayrollOverview: 'ਤਨਖਾਹ ਸੰਖੇਪ',
  adminPayrollTotalOperators: 'ਕੁੱਲ ਓਪਰੇਟਰ',
  adminPayrollTotalGross: 'ਕੁੱਲ ਦੇਣਯੋਗ',
  adminPayrollTotalNet: 'ਕੁੱਲ ਨੈੱਟ ਦੇਣਯੋਗ',
  adminPayrollNoData: 'ਇਸ ਮਹੀਨੇ ਲਈ ਤਨਖਾਹ ਡਾਟਾ ਨਹੀਂ',
  subTabSchedule: 'ਸਮਾਂ-ਸਾਰਣੀ',
  subTabHistory: 'ਇਤਿਹਾਸ',
  subTabAnalytics: 'ਵਿਸ਼ਲੇਸ਼ਣ',
  clientAnalyticsTitle: 'ਬੁਕਿੰਗ ਵਿਸ਼ਲੇਸ਼ਣ',
  clientAnalyticsSpend: 'ਕੁੱਲ ਖਰਚ',
  clientAnalyticsHours: 'ਕੁੱਲ ਘੰਟੇ',
  clientAnalyticsBookings: 'ਪੂਰੀਆਂ ਬੁਕਿੰਗ',
  clientAnalyticsMachines: 'ਵਰਤੀਆਂ ਮਸ਼ੀਨਾਂ',
  clientAnalyticsAvgSpend: 'ਪ੍ਰਤੀ ਬੁਕਿੰਗ ਔਸਤ',
  clientAnalyticsMonthlyTrend: 'ਮਾਸਿਕ ਖਰਚ ਰੁਝਾਨ',
  clientAnalyticsTopMachines: 'ਸਿਖਰਲੀਆਂ ਮਸ਼ੀਨਾਂ',
  clientAnalyticsNoData: 'ਇਸ ਅਵਧੀ ਵਿੱਚ ਕੋਈ ਪੂਰੀ ਬੁਕਿੰਗ ਨਹੀਂ',
  operatorAnalyticsTitle: 'ਕੰਮ ਵਿਸ਼ਲੇਸ਼ਣ',
  operatorAnalyticsPresentDays: 'ਹਾਜ਼ਰ ਦਿਨ',
  operatorAnalyticsHalfDays: 'ਅੱਧਾ ਦਿਨ',
  operatorAnalyticsHmr: 'ਕੁੱਲ HMR',
  operatorAnalyticsJobs: 'ਪੂਰੇ ਕੰਮ',
  operatorAnalyticsIssues: 'ਰਿਪੋਰਟ ਕੀਤੇ ਮੁੱਦੇ',
  operatorAnalyticsAvgHmr: 'ਔਸਤ HMR/ਦਿਨ',
  operatorAnalyticsMonthlyTrend: 'ਮਹੀਨਾਵਾਰ ਕੰਮ ਟ੍ਰੈਂਡ',
  operatorAnalyticsIssueBreakdown: 'ਕਿਸਮ ਅਨੁਸਾਰ ਮੁੱਦੇ',
  operatorAnalyticsRecentJobs: 'ਹਾਲ ਦੇ ਕੰਮ',
  operatorAnalyticsNoData: 'ਇਸ ਅਵਧੀ ਵਿੱਚ ਕੰਮ ਰਿਕਾਰਡ ਨਹੀਂ',
  adminServiceAlertsTitle: 'ਸੇਵਾ ਅਲਰਟ',
  adminServiceAllOk: 'ਸਾਰੀਆਂ ਮਸ਼ੀਨਾਂ ਦੇ ਸੇਵਾ ਰਿਕਾਰਡ ਅਪ-ਟੂ-ਡੇਟ ਹਨ ✅',
  adminServiceNoRecord: 'ਕੋਈ ਰਿਕਾਰਡ ਨਹੀਂ',
  adminServiceColLastService: 'ਆਖਰੀ ਸੇਵਾ',
  adminServiceColNextDue: 'ਅਗਲੀ Due',
  adminServiceColServiceStatus: 'ਸੇਵਾ ਸਥਿਤੀ',
  adminMachinesColMinHrs: 'ਘੱਟੋ-ਘੱਟ ਘੰਟੇ',
  adminMachinesColRateDay: 'ਦਰ/ਦਿਨ',
  adminClientName: 'ਗਾਹਕ ਦਾ ਨਾਮ',
  adminOwnerName: 'ਮਾਲਕ ਦਾ ਨਾਮ',
  adminPayoutWallet: 'ਭੁਗਤਾਨ ਵਾਲੇਟ',
  adminFooterMachines: 'ਮਸ਼ੀਨਾਂ',
  adminFooterClients: 'ਗ੍ਰਾਹਕ',
  adminFooterOwners: 'ਮਾਲਕ',
  auditSeverityCritical: 'ਗੰਭੀਰ',
  auditSeverityHigh: 'ਉੱਚ',
  auditSeverityMedium: 'ਮੱਧਮ',
  auditSeverityNormal: 'ਸਧਾਰਨ',
  auditCopyEvent: 'ਇਵੈਂਟ ਕਾਪੀ ਕਰੋ',
  auditViewDetails: 'ਵੇਰਵੇ ਦੇਖੋ',
  auditHideDetails: 'ਵੇਰਵੇ ਲੁਕਾਓ',
  auditCopyJson: 'JSON ਕਾਪੀ ਕਰੋ',
  auditNoLogs: 'ਕੋਈ ਆਡਿਟ ਲੌਗ ਨਹੀਂ',
  auditIntroBanner: 'ਲੌਗਇਨ, ਐਡਮਿਨ ਕਾਰਵਾਈਆਂ ਅਤੇ ਸੁਰੱਖਿਆ ਘਟਨਾਵਾਂ। ਫਿਲਟਰ ਲੋਡ ਕੀਤੇ ਨਤੀਜਿਆਂ ਤੇ ਲਾਗੂ ਹੁੰਦੇ ਹਨ; ਪੁਰਾਣੀਆਂ ਕਤਾਰਾਂ ਲਈ ਹੋਰ ਲੋਡ ਕਰੋ।',
  auditLoaded: 'ਲੋਡ ਕੀਤੇ',
  auditMoreAvailable: 'ਹੋਰ ਉਪਲਬਧ',
  auditEndOfList: 'ਸੂਚੀ ਸਮਾਪਤ',
  auditFilterActive: 'ਫਿਲਟਰ ਸਕ੍ਰਿਆ',
  auditFiltersActive: 'ਫਿਲਟਰ ਸਕ੍ਰਿਆ',
  auditSeverityBreakdown: 'ਗੰਭੀਰਤਾ ਵੰਡ (ਮੌਜੂਦਾ ਸੂਚੀ)',
  auditPressSlash: 'ਕਾਰਵਾਈ ਫਿਲਟਰ ਤੇ ਫੋਕਸ ਕਰਨ ਲਈ / ਦਬਾਓ',
  auditFilters: 'ਫਿਲਟਰ',
  auditFilterActionPlaceholder: 'Filter action (e.g. dlq_retry)',
  auditFilterActorPlaceholder: 'Filter actorId',
  auditAllRoles: 'ਸਾਰੀਆਂ ਭੂਮਿਕਾਵਾਂ',
  auditFilterEntityPlaceholder: 'Entity type (e.g. dead_letter_queue)',
  auditFilterMetaPlaceholder: 'ਮੈਟਾਡੇਟਾ JSON ਖੋਜੋ',
  auditFilterFromPlaceholder: 'ਸ਼ੁਰੂਆਤੀ ਤਾਰੀਖ ਅਤੇ ਸਮਾਂ',
  auditFilterToPlaceholder: 'ਅੰਤ ਤਾਰੀਖ ਅਤੇ ਸਮਾਂ',
  audit24h: '24h',
  audit7d: '7d',
  auditTimezonePrefix: 'ਸਮਾਂ ਖੇਤਰ:',
  auditTimezoneSuffix: '(ਸਥਾਨਕ)',
  auditHideCsvOptions: 'CSV ਕਾਲਮ ਵਿਕਲਪ ਲੁਕਾਓ',
  auditShowCsvOptions: 'CSV ਕਾਲਮ ਵਿਕਲਪ ਦਿਖਾਓ',
  auditCsvColCreatedAt: 'ਬਣਾਉਣ ਦਾ ਸਮਾਂ',
  auditCsvColAction: 'ਕਾਰਵਾਈ',
  auditCsvColActorId: 'Actor ID',
  auditCsvColActorRole: 'Actor Role',
  auditCsvColEntityType: 'Entity Type',
  auditCsvColEntityId: 'Entity ID',
  auditCsvColMetadata: 'ਮੈਟਾਡੇਟਾ',
  auditFooterLoaded: 'ਲੋਡ ਕੀਤੇ',
  auditFooterLogs: 'ਆਡਿਟ ਲੌਗ',
  auditFooterMoreAvailable: '(ਹੋਰ ਉਪਲਬਧ)',
  auditFooterAllLoaded: '(ਸਾਰੇ ਲੋਡ ਕੀਤੇ)',
  auditActor: 'ਐਕਟਰ',
  auditEntity: 'ਇਕਾਈ',
  auditEventLog: 'ਇਵੈਂਟ ਲੌਗ',
  notificationCenter: 'ਸੂਚਨਾਵਾਂ',
  notifChannelAll: 'ਸਭ',
  notifChannelWhatsapp: 'WhatsApp',
  notifChannelEmail: 'ਈਮੇਲ',
  notifChannelPush: 'ਪੁਸ਼',
  notifChannelSms: 'SMS',
  notifStatusSent: 'ਭੇਜਿਆ ਗਿਆ',
  notifStatusFailed: 'ਅਸਫਲ',
  notifStatusPending: 'ਬਕਾਇਆ',
  notifEmpty: 'ਹਾਲੇ ਕੋਈ ਸੂਚਨਾ ਨਹੀਂ',
  notifLoadMore: 'ਹੋਰ ਲੋਡ ਕਰੋ',
  adminNotifLog: 'ਸੂਚਨਾ ਲੌਗ',
  adminNotifColUser: 'ਉਪਭੋਗਤਾ',
  adminNotifColRole: 'ਭੂਮਿਕਾ',
  adminNotifNoData: 'ਹਾਲੇ ਤੱਕ ਕੋਈ ਸੂਚਨਾ ਲੌਗ ਨਹੀਂ',
  etaOwnerApproval: 'ਮਾਲਕ ਦੀ ਮਨਜ਼ੂਰੀ ਦੀ ਉਡੀਕ',
  etaWorkInProgress: 'ਅਨੁਮਾਨਿਤ ਪੂਰਨਤਾ',
  etaPaymentDeadline: 'ਭੁਗਤਾਨ ਪੁਸ਼ਟੀ ਦੀ ਅੰਤਿਮ ਮਿਤੀ',
  etaWorkCompleted: 'ਕੰਮ ਪੂਰਾ ਹੋਇਆ',
  etaDisputeReview: 'DE ਟੀਮ ਵਿਵਾਦ ਦੀ ਸਮੀਖਿਆ ਕਰ ਰਹੀ ਹੈ',
  etaMinutesRemaining: '{n} ਮਿੰਟ ਬਾਕੀ',
  etaHoursRemaining: '{n} ਘੰਟੇ ਬਾਕੀ',
  txRecharge: 'ਵਾਲੇਟ ਰੀਚਾਰਜ',
  txBookingAdvance: 'ਬੁਕਿੰਗ ਐਡਵਾਂਸ',
  txBookingPayment: 'ਬੁਕਿੰਗ ਭੁਗਤਾਨ',
  txSettlement: 'ਸੈਟਲਮੈਂਟ',
  txRefund: 'ਰਿਫੰਡ',
  txPenalty: 'ਜੁਰਮਾਨਾ',
  txCommission: 'ਕਮਿਸ਼ਨ',
  tacTitle: "नियम और शर्तें",
  tacPrivacy: "गोपनीयता नीति",
  tacRefund: "रिफंड नीति",
  tacCancellation: "रद्दीकरण नीति",
  tacServiceDelivery: "सेवा वितरण नीति",
  tacIntro: "बुकिंग से पहले हमारी नीतियाँ देखें",
  tacBannerTitle: "नियम अपडेट उपलब्ध",
  tacBannerOpen: "नियम खोलें",
  tacBannerAgree: "मैंने पढ़ लिया है और सहमत हूँ",
  tacBannerLater: "बाद में",
  clientPoliciesTitle: "ग्राहक नीतियाँ",
  machineGroupAvailable: "उपलब्ध",
  machineGroupBusy: "व्यस्त",
  dewateringReferral: "डीवाटरिंग (पंप) सेवा चाहिए? MachineOS जल्द पंप ठेकेदार सेवाएँ जोड़ेगा। रेफरल के लिए सपोर्ट से संपर्क करें।",
  noActiveWork: "इस महीने कोई सक्रिय कार्य नहीं",
  accountTab: "ਖਾਤਾ",
  recentActivity: "ਤਾਜ਼ਾ ਗਤੀਵਿਧੀ",
  goodMorning: "ਸ਼ੁਭ ਸਵੇਰ",
  goodAfternoon: "ਸ਼ੁਭ ਦੁਪਹਿਰ",
  goodEvening: "ਸ਼ੁਭ ਸ਼ਾਮ",
  thisMonthEarned: 'This month earned',
  standardBookings: 'Standard bookings',
  activeContracts: 'Active contracts',
  contractsOngoing: 'Contracts ongoing',
  noActiveContracts: 'None this period',
  quotationsPending: 'Quotations awaiting reply',
  allUpToDate: 'All bookings up to date',
  noBookingsInPeriod: 'No bookings in this period',
  contractBookings: 'Contract bookings',
  noContractsInPeriod: 'No contracts in this period',
  mobilizationReleased: 'Mobilization released',
  pendingRelease: 'Pending release',
  raBills: 'RA-bills',
  disputed: 'Disputed',
  all: 'All',
  completed: 'Completed',
};
